import { Trendbase, ChartOffsets } from "./trendbase.js";
import { trendWorker } from "../../observer/trendWorker.js";
import { Pen } from "./pen.js";
import { UiModal } from '../common/modal/modal.js';
import { ObjectTree } from "./objecttree.js";
import { Sampler } from "./sampler.js";
import { toBool, isGoodStatusCode } from "../../lib/utils.js";
import {
    getFormattedValue,
    processScaleType,
    unprocessScaleType,
    deepClone,
    convertMillisecondsToTime,
} from "../../lib/utils.js";
import { Legend } from './legend/legend.js';
import { TimeInterval } from './timeinterval.js'
import { TrendKits } from './kits/kits.js'
import { TrendGroup } from "./groups/group.js";
import { TrendTable } from './table/table.js'
import styles from './trend.css'

const startArrowIcon = '<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"14\\" height=\\"12\\" viewBox=\\"0 0 14 12\\"><path d=\\"M13.29 11.29C13.68 10.9 13.68 10.27 13.29 9.87998L9.41998 5.99998L13.3 2.11998C13.69 1.72998 13.69 1.09998 13.3 0.70998C12.91 0.31998 12.28 0.31998 11.89 0.70998L7.29998 5.29998C6.90998 5.68998 6.90998 6.31998 7.29998 6.70998L11.89 11.3C12.27 11.68 12.9 11.68 13.29 11.29Z\\"/><path d=\\"M6.69998 11.29C7.08998 10.9 7.08998 10.27 6.69998 9.87998L2.82998 5.99998L6.70998 2.11998C7.09998 1.72998 7.09998 1.09998 6.70998 0.70998C6.31998 0.31998 5.68998 0.31998 5.29998 0.70998L0.70998 5.29998C0.31998 5.68998 0.31998 6.31998 0.70998 6.70998L5.29998 11.3C5.67998 11.68 6.30998 11.68 6.69998 11.29Z\\"/></svg>';
const leftArrowIcon = '<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"8\\" height=\\"12\\" viewBox=\\"0 0 8 12\\"><path d=\\"M6.70998 9.87998L2.82998 5.99998L6.70998 2.11998C7.09998 1.72998 7.09998 1.09998 6.70998 0.70998C6.31998 0.31998 5.68998 0.31998 5.29998 0.70998L0.70998 5.29998C0.31998 5.68998 0.31998 6.31998 0.70998 6.70998L5.29998 11.3C5.68998 11.69 6.31998 11.69 6.70998 11.3C7.08998 10.91 7.09998 10.27 6.70998 9.87998Z\\"/></svg>';
const rightArrowIcon = '<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"8\\" height=\\"12\\" viewBox=\\"0 0 8 12\\"><path d=\\"M1.29006 9.87998L5.17006 5.99998L1.29006 2.11998C0.900059 1.72998 0.900059 1.09998 1.29006 0.70998C1.68006 0.31998 2.31006 0.31998 2.70006 0.70998L7.29006 5.29998C7.68006 5.68998 7.68006 6.31998 7.29006 6.70998L2.70006 11.3C2.31006 11.69 1.68006 11.69 1.29006 11.3C0.910059 10.91 0.900059 10.27 1.29006 9.87998Z\\"/></svg>';
const endArrowIcon = '<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"14\\" height=\\"12\\" viewBox=\\"0 0 14 12\\"><path d=\\"M0.700215 0.710011C0.310215 1.10001 0.310215 1.73001 0.700215 2.12001L4.58021 6.00001L0.700215 9.88001C0.310215 10.27 0.310215 10.9 0.700215 11.29C1.09021 11.68 1.72022 11.68 2.11022 11.29L6.70021 6.70001C7.09021 6.31001 7.09021 5.68001 6.70021 5.29001L2.12021 0.710011C1.73021 0.320011 1.09021 0.320011 0.700215 0.710011Z\\"/><path d=\\"M7.29021 0.710022C6.90021 1.10002 6.90021 1.73002 7.29021 2.12002L11.1702 6.00002L7.29021 9.88002C6.90021 10.27 6.90021 10.9 7.29021 11.29C7.68021 11.68 8.31021 11.68 8.70021 11.29L13.2902 6.70002C13.6802 6.31002 13.6802 5.68002 13.2902 5.29002L8.70021 0.700022C8.32021 0.320022 7.68021 0.320022 7.29021 0.710022Z\\"/></svg>';
const logScaleIcon = `<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"18\\" height=\\"17\\" fill=\\"none\\" viewBox=\\"0 0 18 17\\"><path fill-rule=\\"evenodd\\" d=\\"M1 0H0v17h18v-1H1V0Zm5.142 5.882L4.571 3.257l.858-.514 1.55 2.588 1.226 1.423 1.852-1.29.057-.039.064-.022 2.515-.875.08-.028H16v1h-3.058l-2.37.825L8.883 7.5l1.69 1.175 2.369.825H16v1h-3.227l-.08-.028-2.514-.875-.065-.022-.057-.04-1.852-1.289-1.227 1.423-1.549 2.588-.858-.514 1.571-2.625.023-.037.028-.032L7.528 7.5 6.193 5.951l-.028-.032-.023-.037ZM3 13h1v1H3v-1ZM4 1H3v1h1V1Zm1 12h1v1H5v-1Zm13-9V3h-1v1h1ZM4 3v1H3V3h1Zm2-2H5v1h1V1Zm1 12h1v1H7v-1Zm10-7h1V5h-1v1ZM4 5v1H3V5h1Zm4-4H7v1h1V1Zm1 12h1v1H9v-1Zm8-5h1V7h-1v1ZM4 7v1H3V7h1Zm6-6H9v1h1V1Zm1 12h1v1h-1v-1Zm6-3h1V9h-1v1ZM4 9v1H3V9h1Zm8-8h-1v1h1V1Zm1 12h1v1h-1v-1Zm5-1v-1h-1v1h1ZM4 11v1H3v-1h1ZM14 1h-1v1h1V1Zm1 12h1v1h-1v-1Zm3 1v-1h-1v1h1ZM15 1h1v1h-1V1Zm3 0h-1v1h1V1Z\\" clip-rule=\\"evenodd\\"/></svg>`
const yDataZoomIcon = `<svg width=\\"24\\" height=\\"24\\" viewBox=\\"0 0 24 24\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\"><rect width=\\"13\\" height=\\"22\\" transform=\\"translate(3 1)\\"/><rect x=\\"3.99927\\" y=\\"2\\" width=\\"11\\" height=\\"9.5\\" fill=\\"#D9D9D9\\"/><rect x=\\"3.99927\\" y=\\"12.5\\" width=\\"11\\" height=\\"9.5\\" fill=\\"#D9D9D9\\"/><path d=\\"M18 2.52637H19.5M21 2.52637H19.5M19.5 2.52637V22.0001M18 21.5472H21M18 12.0368H21\\" stroke=\\"black\\"/></svg>`
const xDataZoomIcon = `<svg width=\\"24\\" height=\\"24\\" viewBox=\\"0 0 24 24\\" fill=\\"none\\" xmlns=\\"http://www.w3.org/2000/svg\\"><rect width=\\"13\\" height=\\"22\\" transform=\\"translate(1 21) rotate(-90)\\"/><rect x=\\"2.00073\\" y=\\"20\\" width=\\"11\\" height=\\"9.5\\" transform=\\"rotate(-90 2.00073 20)\\" fill=\\"#D9D9D9\\"/><rect x=\\"12.4995\\" y=\\"20\\" width=\\"11\\" height=\\"9.5\\" transform=\\"rotate(-90 12.4995 20)\\" fill=\\"#D9D9D9\\"/><path d=\\"M2.52637 6L2.52637 4.5M2.52637 3L2.52637 4.5M2.52637 4.5L22.0001 4.5M21.5472 6L21.5472 3M12.0368 6L12.0368 3\\" stroke=\\"black\\"/></svg>`

const logOne = `<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"16\\" height=\\"19\\" fill=\\"none\\" viewBox=\\"0 0 16 19\\"><path fill-rule=\\"evenodd\\" d=\\"M.355.016h14.12v3.056h-1V1.016H1.354v16.89h7.849v-4.27h4.27v-2.897h1v3.7l-.146.146-4.175 4.175-.146.146H.355V.016ZM3.84 8.9V4.537h1.055v3.508H6.71V8.9H3.84Zm7.365-2.182c0 .48-.092.887-.277 1.221a1.887 1.887 0 0 1-.75.76 2.15 2.15 0 0 1-1.057.26A2.14 2.14 0 0 1 8.062 8.7a1.909 1.909 0 0 1-.748-.76c-.183-.335-.275-.741-.275-1.22 0-.48.092-.887.275-1.22a1.89 1.89 0 0 1 .748-.761c.314-.174.667-.26 1.06-.26.39 0 .742.086 1.056.26.315.173.565.427.75.76.185.334.277.741.277 1.221Zm-1.078 0c0-.284-.04-.524-.122-.72a.944.944 0 0 0-.345-.445.94.94 0 0 0-.539-.151.946.946 0 0 0-.539.15.968.968 0 0 0-.347.446 1.92 1.92 0 0 0-.12.72c0 .284.04.524.12.72a.957.957 0 0 0 .347.446c.15.1.33.151.54.151.21 0 .389-.05.538-.151a.947.947 0 0 0 .345-.446c.081-.196.122-.436.122-.72Zm4.557-.756a.766.766 0 0 0-.106-.237.681.681 0 0 0-.407-.285 1.037 1.037 0 0 0-.29-.038.974.974 0 0 0-.55.153.985.985 0 0 0-.355.447 1.791 1.791 0 0 0-.126.71c0 .28.04.518.121.716a.972.972 0 0 0 .352.452c.153.103.34.155.558.155.193 0 .357-.031.49-.094a.69.69 0 0 0 .307-.27c.066-.11.1-.24.104-.388h-.865v-.77H15.8v.578c0 .39-.083.725-.25 1.004a1.658 1.658 0 0 1-.681.641c-.289.15-.62.224-.995.224a2.17 2.17 0 0 1-1.098-.27 1.875 1.875 0 0 1-.737-.772c-.176-.335-.264-.733-.264-1.193 0-.358.053-.676.16-.953a1.925 1.925 0 0 1 1.11-1.146c.252-.1.524-.15.816-.15.253 0 .488.037.705.11.219.072.412.174.58.306.169.132.306.29.41.471.106.182.171.382.197.599h-1.068Z\\" clip-rule=\\"evenodd\\"/></svg>`
const logAll = `<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"18\\" height=\\"21\\" fill=\\"none\\" viewBox=\\"0 0 18 21\\"><path fill-rule=\\"evenodd\\" d=\\"M.544.956h-.5V17.19h3.22v-1h-2.22V1.956h10.97v1.176H3.31v17.324h8.868l.146-.147 3.81-3.808.145-.147V12.96h-1v2.643h-3.852v3.853H4.309V4.132h10.97v1.832h1V3.132h-3.264V.956H.545Zm5.467 6.49v4.363h2.87v-.857H7.066V7.445H6.01Zm7.088 3.402c.184-.334.277-.741.277-1.221 0-.48-.093-.887-.277-1.221a1.887 1.887 0 0 0-.75-.76 2.15 2.15 0 0 0-1.057-.26c-.392 0-.745.086-1.06.26a1.89 1.89 0 0 0-.747.76c-.183.334-.275.74-.275 1.22s.092.886.275 1.22c.185.332.434.586.748.76a2.14 2.14 0 0 0 1.059.262c.39 0 .743-.086 1.057-.26.315-.173.565-.426.75-.76Zm-.923-1.941c.081.196.121.436.121.72s-.04.524-.121.72a.944.944 0 0 1-.345.445.94.94 0 0 1-.54.152.946.946 0 0 1-.538-.152.958.958 0 0 1-.348-.445 1.92 1.92 0 0 1-.119-.72c0-.284.04-.524.12-.72a.958.958 0 0 1 .347-.446c.15-.1.33-.15.539-.15.21 0 .39.05.539.15.15.101.266.25.345.446Zm4.572-.273a.769.769 0 0 1 .107.237h1.067a1.542 1.542 0 0 0-.196-.6 1.625 1.625 0 0 0-.41-.47 1.884 1.884 0 0 0-.58-.307 2.217 2.217 0 0 0-.706-.109c-.29 0-.563.05-.816.15a1.924 1.924 0 0 0-1.11 1.146 2.65 2.65 0 0 0-.16.952c0 .46.088.858.265 1.194.176.333.422.59.737.77.315.181.681.271 1.097.271.375 0 .707-.074.995-.223.29-.15.517-.363.682-.642.166-.278.25-.613.25-1.003v-.578h-1.882v.77h.865a.777.777 0 0 1-.104.387.69.69 0 0 1-.307.27 1.151 1.151 0 0 1-.49.095.973.973 0 0 1-.559-.156.972.972 0 0 1-.351-.452 1.887 1.887 0 0 1-.121-.715c0-.279.041-.515.125-.71a.985.985 0 0 1 .356-.447.974.974 0 0 1 .55-.154c.105 0 .201.013.29.038a.681.681 0 0 1 .407.286Z\\" clip-rule=\\"evenodd\\"/></svg>`
const logOne1 = `<svg xmlns=\\"http://www.w3.org/2000/svg\\" width=\\"16\\" height=\\"19\\" fill=\\"none\\" viewBox=\\"0 0 16 19\\"><path fill-rule=\\"evenodd\\" d=\\"M.355.016h14.12v3.056h-1V1.016H1.354v16.89h7.849v-4.27h4.27v-2.897h1v3.7l-.146.146-4.175 4.175-.146.146H.355V.016ZM3.84 8.9V4.537h1.055v3.508H6.71V8.9H3.84Zm7.365-2.182c0 .48-.092.887-.277 1.221a1.887 1.887 0 0 1-.75.76 2.15 2.15 0 0 1-1.057.26A2.14 2.14 0 0 1 8.062 8.7a1.909 1.909 0 0 1-.748-.76c-.183-.335-.275-.741-.275-1.22 0-.48.092-.887.275-1.22a1.89 1.89 0 0 1 .748-.761c.314-.174.667-.26 1.06-.26.39 0 .742.086 1.056.26.315.173.565.427.75.76.185.334.277.741.277 1.221Zm-1.078 0c0-.284-.04-.524-.122-.72a.944.944 0 0 0-.345-.445.94.94 0 0 0-.539-.151.946.946 0 0 0-.539.15.968.968 0 0 0-.347.446 1.92 1.92 0 0 0-.12.72c0 .284.04.524.12.72a.957.957 0 0 0 .347.446c.15.1.33.151.54.151.21 0 .389-.05.538-.151a.947.947 0 0 0 .345-.446c.081-.196.122-.436.122-.72Zm4.557-.756a.766.766 0 0 0-.106-.237.681.681 0 0 0-.407-.285 1.037 1.037 0 0 0-.29-.038.974.974 0 0 0-.55.153.985.985 0 0 0-.355.447 1.791 1.791 0 0 0-.126.71c0 .28.04.518.121.716a.972.972 0 0 0 .352.452c.153.103.34.155.558.155.193 0 .357-.031.49-.094a.69.69 0 0 0 .307-.27c.066-.11.1-.24.104-.388h-.865v-.77H15.8v.578c0 .39-.083.725-.25 1.004a1.658 1.658 0 0 1-.681.641c-.289.15-.62.224-.995.224a2.17 2.17 0 0 1-1.098-.27 1.875 1.875 0 0 1-.737-.772c-.176-.335-.264-.733-.264-1.193 0-.358.053-.676.16-.953a1.925 1.925 0 0 1 1.11-1.146c.252-.1.524-.15.816-.15.253 0 .488.037.705.11.219.072.412.174.58.306.169.132.306.29.41.471.106.182.171.382.197.599h-1.068Z\\" clip-rule=\\"evenodd\\"/></svg>`

const penlimits = {
    2: {
        name: "hihi",
        data: {
            backgroundcolor: "red",
            color: "red",
            linestyle: 0,
            thickness: 1,
            isvisible: true,
        }
    },
    1: {
        name: "hi",
        data: {
            backgroundcolor: "yellow",
            color: "orange",
            linestyle: 0,
            thickness: 1,
            isvisible: true,
        }
    },
    3: {
        name: "lo",
        data: {
            backgroundcolor: "yellow",
            color: "orange",
            linestyle: 0,
            thickness: 1,
            isvisible: true,
        }
    },
    4: {
        name: "lolo",
        data: {
            backgroundcolor: "red",
            color: "red",
            linestyle: 0,
            thickness: 1,
            isvisible: true,
        }
    }
}

/**
 * @class MSTrend
 * @extends Trendbase
 * @classdesc Тренд
 * */

export class MSTrend extends Trendbase {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "till",
            "autoscroll",
            "autoscrolldefault",
            "autoscaleview",
            "interval",
            "intervaldefault",
            "shift",
            "toolbarbackgroundcolor",
            "toolbariconcolor",
            "hastoggleautoscroll",
            "hasobjecttree",
            "hastable",
            "hasdownloadcsv",
            "hascontrols",
            "hasbrush",
            "haskits",
            "hasgroup",
            "haslogscale",
            "hasydatazoombtn",
            "hasxdatazoombtn",
            "haslegend",
            "hasprint",
            "hassaveimageas",
            "hasreset",
            "resampleinterval",
            "intervalpageturn",
            "updatetime",
            "archivestart",
            "archiveend",
            "yaxisperpen",
            "zoomallaxes",
            "maxpens",
            "penStates",
            "intervalState",
            "curentPenState",
            "usecolorunreliableline",
            "colorunreliableline",
            "styleunreliableline",
            "linejoindefault",
            "drawconstantdefault",
            "pennamelevels",
            "objectuid",
            "isglobal",
            "logscale",
            "autoscaledefault",
            "expandedlevel",
            "expanded",
            "displaynametype",
            "hideinterval",
            "pensdata"
        ]);
    }
    /**
     * @constructor
     * */
    constructor() {
        super();
        this.checkComponent('ui-modal', UiModal)
        const ds = this.tagName == "MS-TRENDDS";
        const option = window._globalParams.Options
        if(option){
            const arrayOption = option.replace(/\s+/g, '').split(',');
            this.isLog = arrayOption.includes("logTrend");
            this.isLogTrendArhive = arrayOption.includes("logTrendArсhive");
        }
        this.log = [];
        this.logArhive = [];
        this.startInitTime = new Date();
        this.cacheOptions = {};
        this.isbusy = false;
        const xdatazoomWidth =
            this.attributes.width.value -
            ChartOffsets.left -
            ChartOffsets.right;
        const c =
            (ChartOffsets.top / this.attributes.height.value) +
            (ChartOffsets.bottom / this.attributes.height.value)
        const ydatazoomWidth = `calc(100% - ${c * 100 + 1.5}%)`
        const shadowRoot = this.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = `
            <style>
                ${styles}
            </style>
            <div class="trend">
                <div class="trend__container" id="trend__container">
                    <ms-toolbar
                        id='toolbar'
                        class="trend__toolbar"
                        style="position: relative;"
                        buttons='[
                            {"method": "ToggleAutoscroll", "class": ["hmi-j-play", "hmi-j-pause"], "tooltip": ["${i18next.t('trend_toolbar_autoscroll')}", "${i18next.t('trend_toolbar_autoscroll')}"], "type": "toggle"},
                            {"method": "ObjectTree", "class": "hmi-j-tree", "tooltip": "${i18next.t('trend_toolbar_objTree')}", "type": "button"},
                            {"method": "", "class": ["hmi-j-tools"], "tooltip": ["${i18next.t('trend_toolbar_table')}", "${i18next.t('trend_toolbar_table')}"], "type": "toggle", "id": "tool-table-btn"},
                            {"method": "DownloadCsv", "class": "hmi-j-export", "tooltip": "${i18next.t('trend_toolbar_export')}", "type": "button"},
                            {"method": "FirstPage", "class": "hmi-j", "tooltip": "${i18next.t('trend_toolbar_pageContols')}", "type": "button", "svg": "${startArrowIcon}"},
                            {"method": "PreviousPage", "class": "hmi-j", "tooltip": "${i18next.t('trend_toolbar_pageContols')}", "type": "button", "svg": "${leftArrowIcon}"},
                            {"method": "NextPage", "class": "hmi-j", "tooltip": "${i18next.t('trend_toolbar_pageContols')}", "type": "button", "svg": "${rightArrowIcon}"},
                            {"method": "LastPage", "class": "hmi-j", "tooltip": "${i18next.t('trend_toolbar_pageContols')}", "type": "button", "svg": "${endArrowIcon}"},
                            {"method": "BrushSet", "class": ["hmi-j-setMark", "hmi-j-setMark"], "tooltip": ["${i18next.t('trend_toolbar_install')}", "${i18next.t('trend_toolbar_install')}"], "type": "toggle"},
                            {"method": "BrushCancel", "class": "hmi-j-clearMark", "tooltip": "${i18next.t('trend_toolbar_clearMark')}", "type": "button"},
                            {"method": "", "class": ["hmi-j-tools"], "tooltip": ["${i18next.t('trend_toolbar_kits')}", "${i18next.t('trend_toolbar_kits')}"], "type": "toggle", "id": "tool-kits-btn"},
                            {"method": "", "class": ["hmi-j-tools"], "tooltip": ["${i18next.t('trend_toolbar_group')}", "${i18next.t('trend_toolbar_group')}"], "type": "toggle", "id": "tool-groups-btn"},
                            {"method": "toggleLogScale", "class": ["hmi-j-tools", "hmi-j-tools"], "tooltip": ["${i18next.t('trend_toolbar_log_disable')}", "${i18next.t('trend_toolbar_log_active')}"], "svg": "${logScaleIcon}", "type": "toggle"},
                            {"method": "toggleYDataZoom", "class": ["hmi-j-tools", "hmi-j-tools"], "tooltip": ["${i18next.t('trend_toolbar_ydatazoom_disable')}", "${i18next.t('trend_toolbar_ydatazoom_active')}"], "svg": "${yDataZoomIcon}", "type": "toggle"},
                            {"method": "toggleXDataZoom", "class": ["hmi-j-tools", "hmi-j-tools"], "tooltip": ["${i18next.t('trend_toolbar_xdatazoom_disable')}", "${i18next.t('trend_toolbar_xdatazoom_active')}"], "svg": "${xDataZoomIcon}", "type": "toggle"},
                            {"type": "expander"},
                            {"method": "ShowLegend", "class": ["hmi-j-trend_legend", "hmi-j-trend_legend"], "tooltip": ["${i18next.t('trend_toolbar_minilegenda')}", "${i18next.t('trend_toolbar_minilegenda')}"], "type": "toggle"},
                            {"method": "Print", "class": "hmi-j-print", "tooltip": "${i18next.t('trend_toolbar_print')}", "type": "button"},
                            ${this.isLog ? `{"method": "exportLog", "class": ["hmi-j-tools", "hmi-j-tools"], "tooltip": ["Скачать log тренда", "Скачать log тренда"], "svg": "${logOne}", "type": "toggle"},` : ''}
                            ${this.isLog ? `{"method": "exportAllTrendsLog", "class": ["hmi-j-tools", "hmi-j-tools"], "tooltip": ["Скачать log всех трендов", "Скачать log всех трендов"], "svg": "${logAll}", "type": "toggle"},` : ''}
                            ${this.isLogTrendArhive ? `{"method": "exportLogArhive", "class": ["hmi-j-tools", "hmi-j-tools"], "tooltip": ["Скачать log архива тренда", "Скачать log архива тренда"], "svg": "${logOne}", "type": "toggle"},` : ''}
                            {"method": "SaveImageAs", "class": "hmi-j-print_screen", "tooltip": "${i18next.t('trend_toolbar_exportGraph')}", "type": "button"},
                            {"method": "ClearOptions", "class": "hmi-j-reset_settings", "tooltip": "${i18next.t('trend_toolbar_reset')}", "type": "button"}
                        ]'
                    ></ms-toolbar>
                    <div id="chart-wrapper" class="trend__chart-wrapper">
                        <ms-datazoom
                            id="ydatazoom"
                            class="trend__ydatazoom"
                            ${ds ? 'locksize="true"' : ""}
                            height="${ydatazoomWidth}"
                            datazoomindex="1"
                            incrementstep="1"
                            precision="0"
                            format="f0"
                            width="20"
                            min="0"
                            max="100"
                            minvalue="0"
                            maxvalue="100"
                            foreborderwidth="2"
                            orientation="1"
                        ></ms-datazoom>
                        <div id="chart" class="trend__chart"></div>
                        <ms-datazoom
                            id="datazoom"
                            class="trend__xdatazoom"
                            style="position: relative;"
                            datazoomindex="0"
                            incrementstep="1"
                            format="dd.MM.yyyy HH:mm:ss"
                            width="${xdatazoomWidth}"
                            height="20"
                            foreborderwidth="2"
                            orientation="0"
                        ></ms-datazoom>
                    </div>
                    <div id="timerinterval-wrap" class="timerinterval-wrap"></div>
                </div> 
                <div class="preloader">
                    <div>${i18next.t('loading')}</div>
                    <div data-loader="timer"></div>
                </div>
            </div>
        `;
        this.cache = { pens: [] }
        this.hasArchive = false; //если архив в тренде не появится после подписок, то горизонтальный ползунок не будет виден
        this._penNamedStates = {};
        this.currentPenSet = "";
        this.setParts(shadowRoot);
        this.dcIndex = 0;
        this.observers = [];
        this.clearObservers = [];
        this._cacheDataSource = [];
        this.extendedSources = []
        this._cacheStringPenChanged = [];
        this.createTrend();
        this.createDataZoom();
        this._showlegend = true;
        this.initialized = false;
        this.awateDataSource = [];
        this.archivedpens = {};
        this.archivedpens.toRequest = [];
        this.penindex = 1; //нумератор для clientHandle-ов
        this.countWaitGetArhive = 0;
        this.datasources = [];
        this.stringpens = [];
        this._pens = [];
        this._markBrush = {};
        this.msdatazoom.echarts = this.echarts;
        this.msydatazoom.echarts = this.echarts;
        this.parentHasPopup = this.parentElement?.closest('ms-popup') !== null;
        this.initTrendOption();
        this.initLegend()
        this.initTrendGroups()
        this.initTrendKits()
        this.initTrendTable()
        this.ydatazoomenable = false;
        this.xdatazoomenable = true;
        if(window.ipc){
            this.ipc = window.ipc.get()
            this.windowId = this.ipc.sendSync("server", "getId");
            this.ipcTrendHandler = this.ipcHandler.bind(this);
            this.ipc.on("client", this.ipcTrendHandler);
        }
        this.intervalContainer = shadowRoot.querySelector("#timerinterval-wrap");
        this.chart = shadowRoot.querySelector("#chart");
        this.chart.addEventListener("dblclick", () => {
            this.ToggleAutoscroll();
        });
        this.echarts.on("finished", () => {
            if (!this._toolXY) return
            this.echarts.dispatchAction({
                type: "showTip",
                x: this._toolXY.x,
                y: this._toolXY.y,
            });
        });
        this.echarts.on("brushEnd", (params) => {
            const sr = this.pens;
            if (params.areas.length === 0) {
                for (let i = 0; i < sr.length; i++) {
                    sr[i].minmax = null;
                }
                return;
            }
            const min = parseInt(params.areas[0].coordRange[0]),
                max = parseInt(params.areas[0].coordRange[1]);
            this._markBrush = { min: min, max: max, set: true };
            for (let i = 0; i < sr.length; i++) {
                const data = sr[i].serie.data;
                let start = -1; //Находим либо ближайшую справа точку к левой границе диапазона, если нет, то первую точку внутри диапазона
                while (
                    start + 1 < data.length &&
                    data[start + 1][0] <= max &&
                    (data[start + 1][0] <= min || start < 0)
                )
                    start++;

                if (start > -1) {
                    const end = data
                        .slice()
                        .reverse()
                        .findIndex((el) => {
                            return el[0] <= max;
                        });
                    if (end > -1) {
                        if (start < data.length - end) {
                            const res = data.slice(start, data.length - end);
                            const minmax = res.reduce(
                                (minMax, currentValue) => {
                                    if (currentValue[1] !== null) {
                                        //null портит весь расчет
                                        minMax[0] = Math.min(
                                            minMax[0],
                                            currentValue[1]
                                        );
                                        minMax[1] = Math.max(
                                            minMax[1],
                                            currentValue[1]
                                        );
                                    }
                                    return minMax;
                                },
                                [Infinity, -Infinity]
                            );
                            if (minmax[0] === Infinity) minmax[0] = "";
                            if (minmax[1] === -Infinity) minmax[1] = "";
                            if (res.length > 0) {
                                minmax[2] = res[0][1];
                                minmax[3] = res[res.length - 1][1];
                            } else {
                                minmax[2] = "";
                                minmax[3] = "";
                            }
                            sr[i].minmax = minmax;
                        } else {
                            if (
                                (sr[i].linejoin ||
                                    data[data.length - end][3]) &&
                                start > 0
                            ) {
                                const value = data[start - 1][1];
                                sr[i].minmax = [value, value, value, value];
                            } else {
                                sr[i].minmax = null;
                            }
                        }
                    } else {
                        sr[i].minmax = null;
                    }
                } else {
                    sr[i].minmax = null;
                }
            }
            this.broadcast();
        });

        const elem = window._globalParams.TrendRenderingType;
        shadowRoot.querySelector(elem).onmousemove = (e) => {
            this._toolXY = { x: e.offsetX, y: e.offsetY };
            if (!this.b) {
                this.b = true;
                requestAnimationFrame(() => {
                    if (this.echarts) {
                        this.echarts._zr.animation.update();
                        this.b = false;
                    }
                });
            }
        };
        shadowRoot.querySelector(elem).onmouseleave = (e) => {
            this._toolXY = null;
        };
        this.toolbar.context = this;
        this.afterSwitch = this.afterSwitch.bind(this);
        window.addEventListener("ms_message", this.afterSwitch);
        this.setPm();
        this._preLoad = shadowRoot.querySelector(".preloader");
        //
        this.msydatazoom.updateForDatazoom = (start, end) => {
            if(!this.pens.length) return
            const pen = this.pens[this.currentPen]
            pen.msydatazoomvalue = { start, end }
            //изменение значения вертикального ползунка
            this.updateAxesForZoom();
            this.echarts &&
                this.echarts.dispatchAction({
                    type: "dataZoom",
                    dataZoomIndex: 1,
                    startValue: start,
                    endValue: end,
                });
            this.saveCurentPenState(start, end);
        };
        this.msdatazoom.updateForDatazoom = (start, end) => {
            this.SetParameterSilent("autoscroll", false);
            this.updateSliderZoom(start, end)
            const interval = this.msdatazoom.maxvalue - this.msdatazoom.minvalue
            if (!isNaN(interval) && interval && this.interval !== interval) this.updateInterval(interval)
            this.getBlocksIfNeeded()
        }
        this.echarts.on("datazoom", (params) => {
            if (params.dataZoomIndex === 1)return;
            if(this.xdatazoomenable){
                if (isNaN(params.startValue) || isNaN(params.endValue)) this.SetParameterSilent("autoscroll", false);
                const minvalue = params.startValue ?? this.datazoom.startValue
                const maxvalue = params.endValue ?? this.datazoom.endValue
                this.SetParameter("till", maxvalue, true)
                this.updateSliderZoom(minvalue, maxvalue)
                this.updateTimeintervalZoom(minvalue, maxvalue)
                let interval = this.msdatazoom.maxvalue - this.msdatazoom.minvalue
                if (!isNaN(interval) && interval && this.interval !== interval) {
                    if (this.till > this.archiveend) this.SetParameter("till", this.archiveend, true);
                    if(this.timeInterval){
                        const defaultDown = this.interval > interval && this.interval > this.timeInterval.select.value && this.timeInterval.select.value > interval
                        const defaultUp = interval > this.interval && interval > this.timeInterval.select.value && this.timeInterval.select.value > this.interval
                        if (defaultDown || defaultUp) {
                            interval = this.timeInterval.select.value
                            this.updateSliderZoom(this.msdatazoom.maxvalue - interval, this.msdatazoom.maxvalue)
                        }
                    }
                    this.updateInterval(interval)
                }
                this.getBlocksIfNeeded();
            } 
            if(this.ydatazoomenable && params.batch){
                for(let i = 0; params.batch.length > i; i++){
                    const batch = params.batch[i];
                    if(batch.dataZoomId === "ydatazoom"){
                        this.updateSliderYZoom(batch.start, batch.end)
                        return
                    }
                }
            }
        })
    }

    ipcHandler(event, ...arg) {
        switch (arg[0]) {
            case "syncTrendKits":
                if(arg[1].trendId === this.id) this.syncKits();
                break;
        }
    }

    toggleTimeinterval() {
        if (!this.hideinterval) {
            this.intervalRootElem = this.shadowRoot.getElementById("timerinterval-wrap");
            this.timeInterval = new TimeInterval(this, this.intervalRootElem);
            if(this.isStateTimeInterval) this.timeInterval.setDefaultState()
            if (this.interval) this.timeInterval.zoomEvent(this.interval)
            this.updateTimeintervalZoom( this.msdatazoom.minvalue, this.msdatazoom.maxvalue)
            setTimeout(() => {
                this.updateHeight(super.height)
            }, 10)
        } else {
            if(this.intervalRootElem) this.intervalRootElem.innerHTML = ''
            this.timeInterval = null
            this.updateHeight(super.height)
        }
    }

    initLegend() {
        this.legend = new Legend(this);
    }

    initTrendKits() {
        const groups = this.toolbar.shadowRoot.querySelector("#tool-kits-btn")
        this.trendKits = new TrendKits(this, groups);
    }

    initTrendGroups() {
        const groups = this.toolbar.shadowRoot.querySelector("#tool-groups-btn")
        this.trendGroups = new TrendGroup(this, groups);
    }

    initTrendTable(){
        const table = this.toolbar.shadowRoot.querySelector("#tool-table-btn")
        this.trendTable = new TrendTable(this, table)
    }

    /**
     * Обновить границы datazoom внутри echarts
     * @param {number} start левая граница полотна
     * @param {number} end правая граница полотна
     */
    updateInsideZoom(start, end) {
        if (!this.echarts || start < 0 || end < 0) return
        this.echarts.dispatchAction({
            type: "dataZoom",
            dataZoomIndex: 0,
            startValue: start,
            endValue: end,
        });
    }

    /**
     * Обновить границы горизонтального ползунка
     * @param {number} start левая граница
     * @param {number} end правая граница
     */
    updateSliderZoom(start, end) {
        this.msdatazoom.minvalue = start >= this.archivestart ? start : this.archivestart
        if (!this.autoscroll) {
            this.msdatazoom.maxvalue = end
        } else {
            this.msdatazoom.maxvalue = end < this.archiveend ? end : this.archiveend
        }
        this.trendTable.updateTable()
    }

    /**
    * Обновить границы горизонтального ползунка
    * @param {number} start левая граница
    * @param {number} end правая граница
    */
    updateSliderYZoom(start, end) {
        this.msydatazoom.minvalue = start
        this.msydatazoom.maxvalue = end
    }

    updateTimeintervalZoom(start, end) {
        if (this.timeInterval) {
            this.timeInterval.startDate = start
            this.timeInterval.endDate = end
            this.height = super.height
        }
    }

    updateInterval(interval) {
        this.isSilentUpdateIterval = true
        this.updateInsideInterval(interval)
        this.height = super.height
    }

    updateInsideInterval(interval){
        this.insidesetinterval = true
        this.SetParameterSilent("interval", interval);
    }

    setChartViewArea(interval) {
        if (this.till > this.archiveend) this.SetParameter("till", this.archiveend, true);
        let start = this.till - interval
        if (start < this.archivestart) start = this.archivestart
        this.msdatazoom.updateForDatazoom(start, this.till)
    }

    getOptionTRN() {
        return (
            $sw.serverState.currentState.features == null ||
            ($sw.serverState.currentState.features & 0x800) != 0
        );
    }
    setPm() {
        const optionTRN = this.getOptionTRN();

        if (!optionTRN && (this._maxpens === undefined || this._maxpens > 3))
            this._maxpens = 3;

        if ($pm.hasPermissions) {
            const ackAll = $pm.checkAllow(
                $pm.getEntryFromElement(this, "TrendAddPens")
            );
            this.toolbar.setEnable(this.toolbar.elements["ObjectTree"], ackAll);

            const print = $pm.checkAllow(
                $pm.getEntryFromElement(this, "TrendPrint")
            );
            this.toolbar.setEnable(this.toolbar.elements["Print"], print);

            const download = $pm.checkAllow(
                $pm.getEntryFromElement(this, "TrendSave")
            );
            this.toolbar.setEnable(
                this.toolbar.elements["DownloadCsv"],
                download
            );
            this.toolbar.setEnable(
                this.toolbar.elements["SaveImageAs"],
                download
            );
        }
    }

    toggleLogScale(){
        const oldValue = this.logscale;
        this.logscale = !oldValue;
        this.updateYAxisesOffset();
        this.pens.series.forEach((item) => {
            item.data.forEach((data) => {
                data[1] = oldValue 
                ? unprocessScaleType(data[1], true) 
                : processScaleType(data[1], true)
            })
        })
        this.pens.forEach((pen) => {
            if(pen.lastValue){
                if(oldValue){
                    pen.lastValue[1] = unprocessScaleType(pen.lastValue[1], true)
                    pen.computed.avarage = unprocessScaleType(pen.computed.avarage, true)
                } else {
                    pen.lastValue[1] = processScaleType(pen.lastValue[1], true);
                    pen.computed.avarage = processScaleType(pen.computed.avarage, true);
                }
            }
        })
        this.legend?.render()
    }

    toggleYDataZoom(){
        const oldValue = this.ydatazoomenable;
        this.ydatazoomenable = !oldValue
    }

    toggleXDataZoom(){
        const oldValue = this.xdatazoomenable;
        this.xdatazoomenable = !oldValue
    }

    afterSwitch(message) {
        const data = message.data;
        switch (data.event) {
            case "afterswitch":
                this.setPm();
                this.update();
                break;
        }
    }
    initTrendOption() {
        this.echarts.setOption({
            tooltip: {
                trigger: "axis",
                show: true,
                hideDelay: 500,
                triggerOn: "mousemove",
                axisPointer: {
                    show: true,
                    animation: false,
                },
                backgroundColor: "rgba(245, 245, 245, 0.8)",
                borderWidth: 1,
                borderColor: "#ccc",
                padding: 10,
                textStyle: {
                    color: "#000",
                },
                position: (pos, params, el, elRect, size) => {
                    // всплывающая подсказка появляется всегда в одном и том же месте
                    return {
                        top: ChartOffsets.top / 2, // для красоты сверху она будет располагаться посередине промежутка между контролами и графиком
                        left: ChartOffsets.left,
                    };
                },
                formatter: (params) => {
                    let objResult = {};
                    let result = "";

                    const uniqSeriesParams = params.filter(
                        (value, index, self) =>
                            index ===
                            self.findIndex(
                                (x) => x.seriesName === value.seriesName
                            )
                    );
                    if (uniqSeriesParams.length !== this.pens.length) {
                        const unknownPens = this.pens.filter(
                            (pen) =>
                                uniqSeriesParams.findIndex(
                                    (serie) =>
                                        serie.seriesName === pen.serie.name
                                ) < 0 && pen.isvisible
                        );
                        const xTime = params[0].axisValue;
                        unknownPens.forEach((pen) => {
                            if (pen.serie.data?.length) {
                                const penValue = pen.serie.data.reduce(
                                    (prev, curr) =>
                                        curr[0] <= xTime &&
                                            Math.abs(curr[0] - xTime) <
                                            Math.abs(prev[0] - xTime)
                                            ? curr
                                            : prev
                                );
                                objResult[pen.serie.name] = {
                                    values: penValue,
                                    yformat: pen.yformat,
                                    name: pen.name
                                };
                            }
                        });
                    }
                    uniqSeriesParams.forEach((pen) => {
                        const index = this.pens.findIndex((e) => {
                            return e.serie.name === pen.seriesName;
                        });
                        if (index >= 0) {
                            let value;
                            let value1 = 0;
                            if (
                                (pen.value ?? false) &&
                                pen.value.length >= 2 &&
                                pen.value[1] != undefined
                            ) {
                                value1 = unprocessScaleType(
                                    pen.value[1],
                                    this._logscale
                                );
                            }
                            if (this.pens[index].isEnum) {
                                let ind = value1;
                                if (this.pens[index].subType.Indexes) {
                                    ind = this.pens[
                                        index
                                    ].subType.Indexes.findIndex(
                                        (el) => el == value1
                                    );
                                }
                                value =
                                    this.pens[index].subType.DisplayValues[ind];
                            } else {
                                objResult[this.pens[index].source] = {
                                    yformat: this.pens[index].yformat,
                                    values: pen.value,
                                    name: this.pens[index].name
                                };
                            }

                            if (!value) return;

                            const stroke = `${pen.seriesName}: ${value}<br>`;
                            if (result.indexOf(stroke) === -1)
                                result = `${result}${stroke}`;
                        }
                    });

                    if (!result) {
                        const keys = Object.keys(objResult).sort();
                        if (!keys.length) return result;
                        result = keys.reduce((res, key) => {
                            const data = unprocessScaleType(
                                objResult[key].values?.[1],
                                this._logscale
                            );
                            if (data !== undefined) {
                                const yformat = objResult[key]?.yformat;
                                const value = yformat
                                    ? getFormattedValue(yformat, data)
                                    : data;
                                res += `${objResult[key].name}: ${value}<br>`;
                            }
                            return res;
                        }, "");
                    }
                    return result;
                },
            },
            xAxis: {
                name: this.xaxislabel,
                type: "time",
                axisLabel: {
                    color: this.textcolor,
                    formatter: (value, index) => {
                        return getFormattedValue(
                            this._xformat,
                            new Date(value)
                        ).replace(" ", "\n");
                    },
                    hideOverlap: true,
                    showMinLabel: true,
                    showMaxLabel: true,
                    borderWidth: 30, // для отступа между значениями по оси Х нужно указать параметр padding, но он почему-то не работает, поэтому приходится заменять padding на прозрачный border
                    borderColor: "transparent",
                },
                axisPointer: {
                    show: true,
                    lineStyle: {
                        color: this.cursorcolor,
                        opacity: 0.5,
                        width: 1,
                    },
                    label: {
                        show: true,
                        formatter: (params) => {
                            return getFormattedValue(
                                this._xformat,
                                new Date(params.value)
                            );
                        },
                        backgroundColor: "#004E52",
                    },
                    handle: {
                        size: 15,
                        color: "#00ff11",
                    },
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: this.gridfill || "#C0C0C0",
                    },
                },
                nameTextStyle: {
                    color: this.textcolor,
                },
                axisTick: {
                    lineStyle: {
                        color: this.tickcolorx,
                    },
                },
                axisLine: {
                    lineStyle: {
                        color: this.axiscolorx,
                    },
                },
            },
            yAxis: {
                axisLabel: {
                    formatter: (val) => Number.isInteger(val) ? val : val.toFixed(1)
                }
            },
        });
        if (Number(this.archivestart)) {
            this.echarts.setOption({ xAxis: { min: this.archivestart } });
        }
        if (Number(this.archiveend)) {
            this.echarts.setOption({
                xAxis: { max: this.archiveend + this._interval },
            });
        }

        this.echarts._zr.animation.stop();
    }
    /**
     * Добавить наблюдателя (для Легенды)
     * @param {any} fn
     */
    addObserver(fn) {
        this.observers.push(fn);
    }
    /**
     * Убрать наблюдателя
     * @param {any} fn
     */
    removeObserver(fn) {
        this.observers = this.observers.filter(
            (subscriber) => subscriber !== fn
        );
    }
    /**
     * Вещание об изменениях (для Легенды)
     * */
    broadcast() {
        this.observers.forEach((subscriber) => {
            subscriber(this.pens)
        });
    }

    /**
     * Добавить наблюдателя для очистки (для Легенды)
     * @param {any} fn
    */
    addObserverClear(fn) {
        this.clearObservers.push(fn);
    }
    /**
        * Убрать наблюдателя
        * @param {any} fn
    */
    removeObserverClear(fn) {
        this.clearObservers = this.clearObservers.filter(
            (subscriber) => subscriber !== fn
        );
    }
    /**
        * Вещание об очистке (для Легенды)
    * */
    clearOptionsLegend() {
        this.clearObservers.forEach((subscriber) => {
                subscriber()
        });
    }

    setScope() {
        const curPen = this.pens[this.currentPen]
        const pen = curPen?.isvisible ? curPen : this.pens.find(pen => pen.isvisible)
        this.currentPen = this.currentPen === pen?.idx ? this.currentPen : pen?.idx
        this.createMarkAreaOption(pen?.penlimits)
    }

    // BrushSet() {
    //     if (!this.pens.length) return;
    //     // if (this.autoscroll) this.SetParameter("autoscroll", false);
    //     this._brushState = !this._brushState
    //     if (this._brushState) this.SetMarkBrush()
    //     else this.BrushCancel()
    //     this.toolbar.setToggleState(this.toolbar.elements["BrushSet"], this._brushState);
    // }
    /**
     * Метод Установить регион
     * */
    BrushSet() {
        if (this.pens.length === 0) return;
        if (this.autoscroll) this.SetParameter("autoscroll", false);
        let brushType = "lineX";
        if (!this._brushState) {
            this._brushState = true;
            this.toolbar.setToggleState(
                this.toolbar.elements["BrushSet"],
                this._brushState
            );
        } else {
            this.SetMarkBrush();
            this._brushState = false;
            brushType = false;
            this.toolbar.setToggleState(
                this.toolbar.elements["BrushSet"],
                this._brushState
            );
        }
        if (this._markBrush.set && this._brushState) {
            this._brushMarkArea = null;
            this._marksLine = null;
            if (this.currentPen)
                this.createMarkAreaOption(this.pens[this.currentPen].penlimits);
            this.echarts.dispatchAction({
                type: "brush",
                areas: [
                    {
                        xAxisIndex: 0,
                        brushType: "lineX",
                        brushMode: "single",
                        range: [this._markBrush.min, this._markBrush.max],
                        coordRange: [this._markBrush.min, this._markBrush.max],
                    },
                ],
            });
        }
        this.echarts.dispatchAction({
            type: "takeGlobalCursor",
            key: "brush",
            brushOption: {
                brushMode: "single",
                brushType: brushType,
            },
        });
    }
    /**
     * Метод Сбросить регион
     * */
    // BrushCancel() {
    //     if (this.pens.length === 0) return;
    //     this._brushState = false
    //     this.toolbar.setToggleState(this.toolbar.elements["BrushSet"], this._brushState);
    //     this.applyMark([], [])
    // }
    BrushCancel() {
        if (this.pens.length === 0) return;
        if (this._markBrush) this._markBrush.set = false;

        let brushType = "lineX";
        this.echarts.dispatchAction({
            type: "brush",
            areas: [],
        });
        if (this._brushState) {
            this.echarts.dispatchAction({
                type: "takeGlobalCursor",
                key: "brush",
                brushOption: {
                    brushMode: "single",
                    brushType: brushType,
                },
            });
        }
        this._brushMarkArea = null;
        this._marksLine = null;
        this.pens.forEach((pen) => {
            if (pen.minmax) {
                delete pen.minmax;
            }
        });
        this.createMarkAreaOption(this.pens[this.currentPen || 0].penlimits);
    }

    SetMarkBrush() {
        if (this.pens.length && this._markBrush.min && this._markBrush.max) {
            this.echarts.dispatchAction({
                type: "brush",
                areas: [],
            });
            this._brushMarkArea = [
                {
                    xAxis: this._markBrush.min,
                    itemStyle: {
                        color: "#aaa",
                        opacity: 0.2,
                    },
                },
                {
                    xAxis: this._markBrush.max,
                },
            ];
            this._marksLine = [
                {
                    label: { formatter: this.axFormater.bind(this) },
                    name: "Start",
                    xAxis: this._markBrush.min,
                },
                {
                    label: { formatter: this.axFormater.bind(this) },
                    name: "End",
                    xAxis: this._markBrush.max,
                },
            ];
            this.setScope()
        }
    }

    setCurrentPenSet(res, setCurrent) {
        if (setCurrent) {
            this.currentPenSet = res;
        }
        // this.minilegend.setlegendheader(res);
        this.saveItemState({ currentPenSetState: res }, this.windowId);
    }

    saveNamedGroup(groupName) {
        const pensForSave = [];
        for (let i = 0; i < this.pens.length; i++) {
            const pen = this.pens[i];
            pensForSave.push({
                source: pen.source,
                color: pen.color,
                miny: pen.miny,
                maxy: pen.maxy,
                thickness: pen.thickness,
                linestyle: pen.linestyle,
                linejoin: pen.linejoin,
                pointtype: pen.pointtype,
                pointsize: pen.pointsize,
                showaxis: pen.showaxis,
                isvisible: pen.isvisible,
                drawconstant: pen.drawconstant,
                autoscale: pen.autoscale,
                groupname: pen.groupname,
                mainpengroup: pen.mainpengroup,
            });
        }

        this._penNamedStates[groupName] = pensForSave;
        this.saveItemState({ penNamedStates: this._penNamedStates }, this.windowId);
    }

    setGroupPens(groupName) {
        const storedState = this.getItemState(this.originPath, this.windowId);
        const groupState = storedState?.penNamedStates?.[groupName]
        if (!groupState) return;
        const oldSources = this.pens?.map(({ source, name }) => ({ id: source, title: name })) || [];
        oldSources.forEach(({ id }) => this.removePen({ PenName: id }))
        const toAdd = groupState.map(pen => ({ PenName: pen.source, title: pen.source.split('.').pop(), color: pen.color }))
        toAdd.forEach((pen) => this.addPenMethod(pen))
        this.updateChartStateView()
    }

    /**
     * Форматирование оси Х
     * @param {number} value значение для форматирования
     * @return {string} форматированное значение
     */
    axFormater(value) {
        return getFormattedValue(this._xformat, new Date(value.value));
    }
    /**
     * Метод Масштабировать
     * @deprecated
     * в последних версиях echarts он перестал работать
     * */
    ZoomIn() {
        this.echarts.dispatchAction({
            type: "takeGlobalCursor",
            key: "dataZoomSelect",
            dataZoomSelectActive: true,
        });
    }
    /**
     * Метод Вернуть масштаб
     * @deprecated
     * */
    ZoomCancel() {
        this.echarts.dispatchAction({
            type: "takeGlobalCursor",
            key: "dataZoomSelect",
            dataZoomSelectActive: false,
        });
    }
    /**
     * Метод Добавить перо
     * @param {any} e объект с источником пера в PenName
     * @example {PenName: "Объекты.Объект 1.Параметр 2"}
     */
    AddPen(obj) {
        if (!obj) return;
        const newPen = { ...obj }
        if (!newPen.PenName) {
            const keys = Object.keys(newPen)
            if (!keys.length) return
            const path = newPen[keys[0]]
            newPen.PenName = path
            newPen.Title = this.setPenNameBySource(path)
        }
        if(!newPen.Title) newPen.Title = this.setPenNameBySource(newPen.PenName)
        if ($pm.hasPermissions) {
            const options = {
                cancel: () => { },
                customText: `${this.elname} Добавлено перо ${newPen.PenName}`,
            };
            $pm.resolveControl(
                this,
                "TrendAddPens",
                () => this.addPenInternal(newPen),
                options
            );
        } else this.addPenInternal(newPen);
        if (!this.currentPen) this.selectPen(this.pens[0].idx)
        if (!this.extendedSources.includes(newPen.PenName)) this.extendedSources.push(newPen.PenName)
        const pen = this.pens.find((pen) => pen.source === obj.PenName)
        pen.isnochangetitle = !!obj.Title
        this.updateYAxises()
        if (this.saveStateFlag) this.saveState()
    }

    addToTrend(obj){
        const hasPen = this.pens.some(pen => pen.source === obj.PenName);
        if(hasPen){
            this.RemovePen(obj)
        } else {
            this.AddPen(obj)
        }
    }

    addPenInternal(obj) {
        const sources = structuredClone(this.sources) || this.pens?.map(({ source, name }) => ({ id: source, title: name })) || [];
        if (!sources.find((x) => x.id === obj.PenName)) {
            sources.push({
                id: obj.PenName,
                title: obj.Title || obj.PenName,
            });
            this.reCreatePens(sources, true);
        }
    }

    /**
     * Добавить перо
     * @param {object} e перо для добавления
     */
    addPenMethod(e) {
        if (!e.PenName) return
        const oldBusy = this.isbusy;
        this.isbusy = true;
        //Новые перья должны по возможности получать новые цвета, а не переиспользовать старые
        let dc = window._enums.DistinguishedColors; //массив "отличных цветов" размера N, dc[N]
        //Пройтись по используемым цветам и собрать их в набор
        let usedColors = new Set();
        this.pens.forEach((pen) => usedColors.add(pen.color));
        if (e.color) usedColors.add(e.color)
        //Есть индекс первого неиспользуемого цвета this.dcIndex
        let i = this.dcIndex; //запоминаем его
        //Если цвета в наборе нет - отдать его, иначе смотреть следующий i = (i + 1) % N
        while (usedColors.has(dc[this.dcIndex])) {
            this.dcIndex = (this.dcIndex + 1) % dc.length;
            if (this.dcIndex == i) {
                //перебрали все цвета, они все есть в наборе, всё равно отдать dc[this.dcIndex]
                break;
            }
        }
        const name = e.title ? e.title : this.setPenNameBySource(e.PenName)
        const npen = this.addPenSerie({
            source: e.PenName,
            name: name,
            index: this.pens.length,
            basic: true,
            color: e.color || dc[this.dcIndex],
            linejoin: this._linejoindefault,
            drawconstant: this._drawconstantdefault,
            autoscale: this._autoscaledefault,
        });

        //следующий цвет будет новый, а не повторный
        this.dcIndex = (this.dcIndex + 1) % dc.length;
        this.addLastAxis();

        const eParams = ['miny', 'maxy', 'unit', 'isvisible', 'showaxis', 'drawconstant', 'linejoin', 'pointsize', 'autoscale'];
        eParams.forEach(param => {
            if (e[param]) {
                npen[param] = e[param];
            }
        });

        this.addDataSource(
            {
                dataSourceId: "MPLCDataSource",
                itemId: 0,
                path: e.PenName,
                queueSize: 0,
                taskId: 0,
                timestampsToReturn: "Source",
                type: "LREAL",
                usesCounts: 1,
            },
            "Pens." + (this.pens.length - 1) + ".DataSource"
        );
        if (this._penStates) {
            const i = this._penStates.findIndex(
                (el) => el.source === npen.source
            );
            if (i >= 0) {
                const penState = this._penStates[i];
                this.setPenStateParams(npen, penState)
                npen.saved = true;
                npen.source = e.PenName;
                npen.yaxislabel = penState.yaxislabel;
                npen.yAxis = this.pens.yaxises[this.pens.length - 1] = { ...npen.yAxis}
            }
        }
        this.updateYAxises();
        this.isbusy = oldBusy;
    }

    setPenStateParams(npen, penState){
        const penStateParams = ['color', 'thickness', 'linestyle ', 'linejoin', 'yformat', 'pointsize', 'pointtype', 'maxy', 'miny', 'showaxis',
             'isvisible', 'drawconstant', 'autoscale', 'unit', 'groupname', 'isnochangetitle', 'mainpengroup'];
        penStateParams.forEach(param => {
            npen[param] = penState[param];
        });
    }

    getYAxis(){
        const yAxisGroup = this.trendGroups?.yAxis?.length ? this.trendGroups.yAxis : []
        const yAxis = this.pens?.yaxises?.length ? this.pens.yaxises : []
        const resultArray = [...yAxisGroup, ...yAxis];
        return resultArray.length ? resultArray : {}
    }

    /**
     * Добавление пера в echarts
     * @param {any} pen структура с базовыми характеристиками пера
     * @example
     * {name: "Параметр 2", index: 1, basic: true, color: "#fcce00"}
     * name - имя параметра
     * index - номер пера в массиве перьев
     * basic - остальные характеристики будут заданы по умолчанию
     * color - цвет пера
     */
    addPenSerie(pen) {
        pen.index = this.pens.length;
        let npen = new Pen(this, pen);
        npen.logscale = this.logscale;
        npen.source = pen.source;
        npen._echarts = this.echarts;
        npen.updateSeriesAxises = this.updateSeriesAxises.bind(this);
        npen.updateYAxisesOffset = this.updateYAxisesOffset.bind(this);
        npen.createMarkAreaOption = this.createMarkAreaOption.bind(this);
        npen.msydatazoom = this.msydatazoom;
        npen.broadcast = this.broadcast.bind(this);
        npen.sampler = new Sampler();
        if (typeof this.currentPen === 'number' && npen.idx === this.currentPen) npen.selected = true
        if (pen.color) npen.color = pen.color;
        this.pens.series.push(npen.serie);
        const npen2 = new Pen(this, pen).serie
        if(!this.usecolorunreliableline){
            npen2.lineStyle.normal.color = pen.color;
        }
        this.pens.series.push(npen2); //дубликат для недостоверной линии
        this.pens.push(npen);
        return npen;
    }
    /**
     * Добавить новую ось в конец
     * */
    addLastAxis() {
        if (this.pens.yaxises.length === undefined) {
            //тренд до этого был совсем пустым
            this.pens.yaxises = [];
            this.createDataZoom();
        }
        this.pens.yaxises.push(this.pens[this.pens.length - 1].yAxis);
    }
    /**
     * Метод Удалить перо
     * @param {any} e объект с источником пера в PenName
     */
    RemovePen(e) {
        if ($pm.hasPermissions) {
            const options = {
                cancel: () => { },
                customText: `${this.elname} Удалено перо ${e.PenName}`,
            };
            $pm.resolveControl(
                this,
                "TrendAddPens",
                this.removePen.bind(this, e),
                options
            );
        } else this.removePen(e);
        if (this.saveStateFlag) this.saveState()
    }
    /**
     * Удаление пера
     * @param {object} e объект с источников пера в PenName
     */
    removePen(e) {
        const deletedPen = this.pens.find(pen => pen.path === e.PenName)
        if (this.currentPen === deletedPen?.idx) this.setScope()
        this.unsubscribeBySource(e);
        this.isRemovingPen = true
        this.updateYAxises();        
        this.echarts.setOption(
            { yAxis: this.getYAxis(),
            series: this.pens.series },
            { replaceMerge: ["series", "yAxis"] }
        );
        this.isRemovingPen = false
        this.sources = this.pens.map(({ source, name }) => ({
            id: source,
            title: name,
        }));
        this.legend?.render()
    }

    /**
     * Обновить оси
     * */
    updateYAxises() {
        if(this.recreatingPens && !this.isRemovingPen) return
        const startFreeIndex = this.trendGroups?.groups?.length || 0
        this.pens.forEach((pen, i) => {
            if(!pen.groupname){
                pen.serie.yAxisIndex = startFreeIndex + i;
                this.pens.series[2 * i + 1].yAxisIndex = startFreeIndex + i;
            } else {
                const group = this.trendGroups?.groups?.find(group => group.name === pen.groupname)
                if(group){
                    const groupIndex = group.index
                    pen.serie.yAxisIndex = groupIndex;
                    this.pens.series[2 * i + 1].yAxisIndex = groupIndex;
                }
            }
        });
        if (this.pens.yaxises.length === 0) {
            //перьев не осталось, но об их отсутствии Легенде нужно сообщить
            this.broadcast();
        }
        this.updateYAxisesOffset();
    }


    /**
     * Обновить отступы в осях
     * */
    updateYAxisesOffset() {
        if(this.recreatingPens && !this.isRemovingPen) return
        if (typeof this.pens.yaxises === "undefined") return;
        if (!this._aixFontF && this.echarts.getModel()) {
            this._aixFontF = this.echarts.getModel().option.textStyle.fontFamily;
            this._aixFontS = this.echarts.getModel().option.textStyle.fontSize;
        }
        let visibleindex = [ChartOffsets.left];
        let prevWidth = 0
        let index = 0
        const groupYaxis = []
        if(this.yaxisperpen){
            this.trendGroups?.groups?.forEach((item) => {
                item.yAxis.show = false;
                let isVisible = false
                const groupPens = this.pens.filter(pen => pen?.groupname === item.name)
                groupPens.forEach(pen => {
                    if(pen.isvisible){
                        isVisible = true
                    }
                })
                if(isVisible){
                    item.yAxis.show = true;
                    const widthYAxisText = this.calcLabelOffset();
                    item.widthyaxistext = widthYAxisText;
                    prevWidth = (widthYAxisText || index ? visibleindex[index] : 0) + 52 + this.calcLabelOffset(false, item.yAxis.name)
                    if (!index) item.yAxis.offset = 0
                    else item.yAxis.offset = visibleindex[index]
                    visibleindex.push(prevWidth)
                    index++
                }
                groupYaxis.push(item.yAxis)
            })
        }
        this.pens.forEach((pen) => {
            if (pen.isvisible && (!pen.groupname || !this.yaxisperpen) && ((pen.showaxis && this.yaxisperpen) || (!this.yaxisperpen && pen.selected))) {
                pen.yAxis.show = true;
                if (pen.maxy) {
                    let formMax = getFormattedValue(
                        pen.getYaxisFormat(),
                            unprocessScaleType(pen.maxy, this._logscale),
                            null,
                            null,
                            true
                        )
                    let formMin = getFormattedValue(
                        pen.getYaxisFormat(),
                            unprocessScaleType(pen.miny, this._logscale),
                            null,
                            null,
                            true
                        )
                    const text = formMax?.length > formMin?.length ? formMax : formMin;
                    pen.widthyaxistext = this.calcLabelOffset(true, text);
                    prevWidth = pen.widthyaxistext + this.calcLabelOffset(false, pen.yAxis.name) + (index ? visibleindex[index] : 0);
                    if (!index) pen.yAxis.offset = 0
                    else pen.yAxis.offset = visibleindex[index]
                } else {
                    const widthYAxisText = this.calcLabelOffset();
                    pen.widthyaxistext = widthYAxisText;
                    prevWidth = (widthYAxisText || index ? visibleindex[index] : 0) + 52 + this.calcLabelOffset(false, pen.yAxis.name) // default offset
                    if (!index) pen.yAxis.offset = 0
                    else pen.yAxis.offset = visibleindex[index]
                }
                visibleindex.push(prevWidth)
                index++
            } else {
                pen.yAxis.show = false;
            }
        });

        this.echarts.setOption({
            grid: { left: visibleindex[visibleindex.length - 1] + ChartOffsets.left },
            yAxis: this.getYAxis(),
            }
        );
    }

    updateScale(){
        if(!this.autoscaleview) return
        const yAxisGroup = this.trendGroups?.yAxis?.length ? this.trendGroups.yAxis : []
        yAxisGroup.forEach((yAxis, index) => {
            if(yAxis.scaleview){
                const allData = []
                this.pens.forEach((pen) => {
                    if(pen.serie.yAxisIndex === index && pen.isvisible){
                        allData.push(...pen.serie.data)
                    }
                })
                if(allData.length){
                    const range = this.calcMaxAndMin(allData)
                    const gap = Math.abs(range.max - range.min) * 0.05;
                    yAxis.max = getFormattedValue(
                        yAxis.yformat,
                        range.max + gap,
                        null,
                        null,
                        true
                    )
                    yAxis.min = getFormattedValue(
                        yAxis.yformat,
                        range.min - gap,
                        null,
                        null,
                        true
                    )
                    yAxis.scale = false
                }
            } 
        })
        this.pens.forEach((pen) => {
            if(pen.autoscale && pen.isvisible){
                const range = this.calcMaxAndMin(pen.serie.data)
                const gap = Math.abs(range.max - range.min) * 0.05;
                pen.yAxis.max = +getFormattedValue(
                    pen.yformat,
                    range.max + gap,
                    null,
                    null,
                    true
                )
                pen.yAxis.min = +getFormattedValue(
                    pen.yformat,
                    range.min - gap,
                    null,
                    null,
                    true
                )
                pen.yAxis.scale = false
            }
        })
        this.echarts.setOption({
            yAxis: this.getYAxis(),
        })
    }

    calcMaxAndMin(pensData){
        const start = this.till - this.interval
        const end = this.till
        if(pensData && pensData.length){
            let min = pensData[0][1]
            let max = pensData[0][1]
            for (let index = 0; index < pensData.length; index++) {
                const element = pensData[index];
                if(start < element[0] && element[0] < end){
                    if(min > element[1]){
                        min = element[1]
                    } else if(max < element[1]){
                        max = element[1]
                    }
                }
            }
            if(max === min){
                max = max * 1.1
            }
            return {min, max}
        } else {
            return {min: 0, max: 100}
        }
    }

    calcLabelOffset(isWidth = true, text = undefined) {
        if (!text) return 0
        const fnSize = document.createElement("span");
        fnSize.style.fontSize = `${this._aixFontS}px`;
        document.body.appendChild(fnSize);
        fnSize.innerText = text
        let result;
        if(isWidth){
            result = Math.ceil(fnSize.getBoundingClientRect().width) + 21; // 1px - axis width + 10px - axisTick width + 10px margin
        } else {
            result = Math.ceil(fnSize.getBoundingClientRect().height);
        }
        fnSize.remove();
        return result
    }

    /**
     * Отписаться от данных пера и удалить перо
     * @param {object} e объект с источников пера в PenName
     */
    unsubscribeBySource(e) {
        this.pens.forEach((pen, i) => {
            if (pen.source === e.PenName) {
                this.unsubscribeById(i);
            }
        });
        let deleted = false;
        for (let i = 0; i < this.pens.length; i++) {
            if (!deleted && this.pens[i].source === e.PenName) {
                this.pens[i].destroy();
                this.pens.splice(i, 1);
                this.pens.series.splice(2 * i, 2);
                this.pens.yaxises.splice(i, 1);
                i--;
                deleted = true;
            } else if (deleted) this.pens[i].idx--;
        }
    }
    /**
     * Включить/выключить автоскролл
     * */
    ToggleAutoscroll() {
        this.SetParameter("autoscroll", !this.autoscroll);
    }
    /**
     * Отписаться от данных пера
     * @param {number} i номер пера в массиве
     */
    unsubscribeById(i) {
        this.sw.DeleteMonitoredDataItems(this.pens[i].monitoredItemId);
        let delFromRequest = false;
        for (let key in this.archivedpens) {
            //перо удалено из середины массива, необходим сдвиг
            if (key === "toRequest") continue;
            let newpens = [];
            for (let apen of this.archivedpens[key]) {
                //перо удалено из середины массива, необходим сдвиг
                if (apen < i) newpens.push(apen);
                else if (apen > i) newpens.push(apen - 1);
                else if (this.archivedpens[key].length == 1)
                    //Единственная перо с данным архивом
                    delFromRequest = true;
            }
            this.archivedpens[key] = newpens;
        }

        this.pens[i].serie.data = [];
        this.pens.series[i * 2].data = [];
        this.pens.series[i * 2 + 1].data = [];
        if (delFromRequest)
            this.archivedpens.toRequest = this.archivedpens.toRequest.filter(
                (element) => element.archiveItemId != this.pens[i].archiveItemId
            );
    }

    /**
     * Обновить связи вертикального echarts datazoom с осями
     * */
    updateAxesForZoom() {
        if (this.zoomallaxes) {
            this.ydatazoom.yAxisIndex = Array.from(
                Array(this.pens.length).keys()
            );
        } else {
            this.ydatazoom.yAxisIndex = this.currentPen;
        }
    }

    updatePenYAxis() {
        const pen = this.pens[this.currentPen]
        if (!pen) return
        if (pen.autoscale) {
            if (this.msydatazoom.isvisible) this.msydatazoom.isvisible = false
        } else if (this.nodeName === "MS-TREND") {
            if (!this.msydatazoom.isvisible && this.showverticalscrollbar) this.msydatazoom.isvisible = true
            let startValue = this.msydatazoom._min
            let endValue = this.msydatazoom._max
            if (this.pens) {
                this.pens.forEach((pen) => {
                    if (pen.maxy > endValue) {
                        endValue = pen.maxy
                    }
                    if (startValue > pen.miny) {
                        startValue = pen.miny
                    }
                })
            }
            const maxValue = this.msydatazoom.maxvalue
            const minValue = this.msydatazoom.minvalue
            if (minValue > startValue || minValue > endValue || pen?.msydatazoomvalue !== undefined) this.msydatazoom.minvalue = pen?.msydatazoomvalue?.start || startValue
            if (maxValue < endValue || maxValue < startValue || pen?.msydatazoomvalue !== undefined) this.msydatazoom.maxvalue = pen?.msydatazoomvalue?.end || endValue
            if (typeof startValue === 'number') this.msydatazoom.min = startValue
            if (typeof endValue === 'number') this.msydatazoom.max = endValue
            this.echarts.dispatchAction?.({
                type: "dataZoom",
                dataZoomIndex: 1,
                startValue: this.msydatazoom.minvalue,
                endValue: this.msydatazoom.maxvalue,
            });
            this.saveCurentPenState(this.msydatazoom.minvalue, this.msydatazoom.maxvalue);
        }
        this.calcRightOffset()
        this.createMarkAreaOption(pen.penlimits); //показать границы
    }

    setVisibleToolbar(name, value) {
        const isVisible = this._toBool(value) && this.getOptionTRN()
        this.toolbar.setVisible(this.toolbar.elements[name], isVisible);
    }

    /**
     * Конец
     * @type {number}
     */
    get till() {
        return this._till;
    }
    set till(value) {
        if (value === "0" || !value) return;
        this._till = +value;
        if (this.saveStateFlag) this.saveStateInterval()
        this.updateSliderZoom(this._till - this.interval, this._till)
        this.updateScale()
    }

    /**
     * Автопрокрутка
     * @type {boolean}
     */
    get autoscroll() {
        return this._autoscroll;
    }
    set autoscroll(value) {
        const saveState = this.saveStateFlag ?? this.getAttribute('savestate') === "1" ? true : false
        if (!this._afterInit && saveState) {
            this.originPath = this.getOriginPath(this.windowId);
            let storedState = this.getItemState(this.originPath, this.windowId);
            if (storedState?.intervalState?.autoscroll !== undefined) value = storedState.intervalState.autoscroll;
        }
        this._autoscroll = this._toBool(value);
        if (saveState) this.saveStateInterval();
        //при отключении не нужно запрашивать архив
        if (this.autoscroll) this._initAutoscroll = true;
        this.getBlocksIfNeeded();
        this.toolbar.setToggleState(this.toolbar.elements["ToggleAutoscroll"], this._autoscroll);
    }

    /**
     * Автопрокрутка по умочанию
     * @type {boolean}
    */
    get autoscrolldefault(){
        return this._autoscrolldefault
    }

    set autoscrolldefault(v){
        this._autoscrolldefault = this._toBool(v);
    }

    /**
     * Начало архива
     * @readonly
     * @type {number}
     */
    get archivestart() {
        return this._archivestart;
    }
    set archivestart(value) {
        this._archivestart = +value;
        this.msdatazoom.min = this._archivestart;
    }
    /**
     * Конец архива
     * @readonly
     * @type {number}
     */
    get archiveend() {
        return this._archiveend;
    }
    set archiveend(value) {
        const oldVal = this._archiveend
        this._archiveend = +value;
        if(oldVal === 0){
            this.initIntervalState();
        }
        this.msdatazoom.max = value
        if (!this.autoscroll && oldVal !== 0) return
        if(this.initedStatedZoom) {
            this.initedStatedZoom = false
            return
        }
        this.SetParameter("till", this.archiveend, true);
    }

    /**
     * Интервал (в мс)
     * @type {number}
     */
    get interval() {
        return this._interval;
    }
    set interval(value) {
        this._interval = +value;
        if (this.saveStateFlag) this.saveStateInterval();
        if (this._interval < 1) this._interval = 1;
        if (this.timeInterval) this.timeInterval.zoomEvent(this.interval)
        if(this.isSilentUpdateIterval){
            this.isSilentUpdateIterval = false;
        } else {
            if(!this._afterInit) return
            this.setChartViewArea(this.interval)
        }
        this.updateScale();
    }

    get intervaldefault(){
        return this._intervaldefault;
    }
    
    set intervaldefault(v){
        this._intervaldefault = toBool(v)
    }

    /**
     * Дерево выбора перьев
     * @type {boolean}
     */
    get intervalpageturn() {
        return this._intervalturn;
    }
    set intervalpageturn(value) {
        this._intervalturn = value;
    }
    /**
     * Период обновления данных
     * @type {number}
     */
    get updatetime() {
        return this._updatetime;
    }
    set updatetime(value) {
        this._updatetime = value;
        if (this.updateTime) clearInterval(this.updateTime);
        this.updateTime = setInterval(
            this.update.bind(this),
            +this._updatetime
        );
    }

    /**
     * toolbar background
     * @type {string}
    */
    get toolbarbackgroundcolor() {
        return this._toolbarbackgroundcolor;
    }
    set toolbarbackgroundcolor(value) {
        this._toolbarbackgroundcolor = value;
        this.toolbar.backgroundcolor = value
    }

    /**
     * toolbar icon color
     * @type {string}
    */
    get toolbariconcolor() {
        return this._toolbariconcolor;
    }
    set toolbariconcolor(value) {
        this._toolbariconcolor = value;
        this.toolbar.coloricon = value
    }

    /**
     * Автопрокрутка
     * @type {boolean}
     */
    get hastoggleautoscroll() {
        return this._hastoggleautoscroll;
    }
    set hastoggleautoscroll(value) {
        this._hastoggleautoscroll = value;
        this.toolbar.setVisible(this.toolbar.elements["ToggleAutoscroll"], this._toBool(value));
    }
    /**
     * Дерево выбора перьев
     * @type {boolean}
     */
    get hasobjecttree() {
        return this._hasobjecttree;
    }
    set hasobjecttree(value) {
        this._hasobjecttree = value;
        this.setVisibleToolbar("ObjectTree", value)
    }
    /**
     * Таблица
     * @type {boolean}
     */
    get hastable() {
        return this._hastable;
    }
    set hastable(value) {
        this._hastable = value;
        const table = this.toolbar.shadowRoot.querySelector("#tool-table-btn")
        if(!table) return
        const isVisible = this._toBool(value) && this.getOptionTRN()
        if (isVisible) {
            table.style.display = '';
        } else {
            table.style.display = "none";
        }
    }
    /**
     * Экспорт в csv
     * @type {boolean}
     */
    get hasdownloadcsv() {
        return this._hasdownloadcsv;
    }
    set hasdownloadcsv(value) {
        this._hasdownloadcsv = value;
        this.setVisibleToolbar("DownloadCsv", value)
    }
    /**
     * Крнтролы
     * @type {boolean}
     */
    get hascontrols() {
        return this._hascontrols;
    }
    set hascontrols(value) {
        this._hascontrols = value;
        let names = ["FirstPage", "PreviousPage", "NextPage", "LastPage"];
        names.forEach((name) => {
            this.setVisibleToolbar(name, value)
        })
    }
    /**
     * Интервылы
     * @type {boolean}
     */
    get hasbrush() {
        return this._hasbrush;
    }
    set hasbrush(value) {
        this._hasbrush = value;
        let names = ["BrushSet", "BrushCancel"];
        names.forEach((name) => {
            this.setVisibleToolbar(name, value)
        })
    }
    
    /**
    * Наборы
    * @type {boolean}
    */
    get haskits() {
        return this._haskits;
    }
    set haskits(value) {
        this._haskits = value;
        const kits = this.toolbar.shadowRoot.querySelector("#tool-kits-btn")
        if(!kits) return
        const isVisible = this._toBool(value) && this.getOptionTRN()
        if (isVisible) {
            kits.style.display = '';
        } else {
            kits.style.display = "none";
        }
    }

    /**
     * Группы
     * @type {boolean}
     */
    get hasgroup() {
        return this._hasgroup;
    }
    set hasgroup(value) {
        this._hasgroup = value;
        const groups = this.toolbar.shadowRoot.querySelector("#tool-groups-btn")
        if(!groups) return
        const isVisible = this._toBool(value) && this.getOptionTRN()
        if (isVisible) {
            groups.style.display = '';
        } else {
            groups.style.display = "none";
        }
    }
    
    /**
     * Логарифмический масштаб
     * @type {boolean}
    */
    get haslogscale() {
        return this._haslogscale;
    }
    set haslogscale(value) {
        this._haslogscale = value;
        this.setVisibleToolbar("toggleLogScale", value)
    }

    /**
     * Кнопка масштабирование полотна по оси Y
     * @type {boolean}
    */
    get hasydatazoombtn() {
        return this._hasydatazoombtn;
    }
    set hasydatazoombtn(value) {
        this._hasydatazoombtn = value;
        this.setVisibleToolbar("toggleYDataZoom", value)
    }

    /**
     * Кнопка масштабирование полотна по оси X
     * @type {boolean}
    */
    get hasxdatazoombtn() {
        return this._hasxdatazoombtn;
    }
    set hasxdatazoombtn(value) {
        this._hasxdatazoombtn = value;
        this.setVisibleToolbar("toggleXDataZoom", value)
    }

    /**
     * Легенда
     * @type {boolean}
     */
    get haslegend() {
        return this._haslegend;
    }
    set haslegend(value) {
        this._haslegend = value;
        this.setVisibleToolbar("ShowLegend", value)
    }

    /**
     * Печать
     * @type {boolean}
     */
    get hasprint() {
        return this._hasprint;
    }
    set hasprint(value) {
        this._hasprint = value;
        this.setVisibleToolbar("Print", value)
    }

    /**
     * Экспорт графики
     * @type {boolean}
     */
    get hassaveimageas() {
        return this._hassaveimageas;
    }
    set hassaveimageas(value) {
        this._hassaveimageas = value;
        this.setVisibleToolbar("SaveImageAs", value)
    }

    /**
     * Сброс
     * @type {boolean}
     */
    get hasreset() {
        return this._hasreset;
    }
    set hasreset(value) {
        this._hasreset = value;
        this.setVisibleToolbar("ClearOptions", value)
    }
    /**
     * Масштабировать по всем осям
     * @type {boolean}
     */
    get zoomallaxes() {
        return this._zoomallaxes;
    }
    set zoomallaxes(value) {
        this._zoomallaxes = this._toBool(value);
        this.updateAxesForZoom();
    }
    /**
     * Логарифмическая шкала
     * @type {boolean}
     */
    get logscale() {
        return this._logscale;
    }
    set logscale(value) {
        this._logscale = this._toBool(value);
        this.pens.forEach((pen, i) => {
            pen.logscale = this._logscale;
        });
        this.toolbar.setToggleState(this.toolbar.elements["toggleLogScale"], this._logscale);
        if (this.legend) this.legend.render?.();
    }

    /**
    * Доступность прокрутки по оси Y
    * @type {boolean}
    */
    get ydatazoomenable() {
        return this._ydatazoomenable;
    }
    set ydatazoomenable(value) {
        this._ydatazoomenable = this._toBool(value);
        this.toolbar.setToggleState(this.toolbar.elements["toggleYDataZoom"], this._ydatazoomenable);
        if(this._ydatazoomenable){
            this.ydatazoom.disabled = false;
            this.ydatazoom.zoomOnMouseWheel = true;
        } else {
            this.ydatazoom.disabled = true;
            this.ydatazoom.zoomOnMouseWheel = false;
        }
    }

    /**
     * Доступность прокрутки по оси X
     * @type {boolean}
     */
    get xdatazoomenable() {
        return this._xdatazoomenable;
    }
    set xdatazoomenable(value) {
        this._xdatazoomenable = this._toBool(value);
        this.toolbar.setToggleState(this.toolbar.elements["toggleXDataZoom"], this._xdatazoomenable);
        if(this._xdatazoomenable){
            this.datazoom.disabled = false;
            this.datazoom.zoomOnMouseWheel = true;
        } else {
            this.datazoom.disabled = true;
            this.datazoom.zoomOnMouseWheel = false;
        }
    }

    get autoscaleview() {
        return this._autoscaleview || false;
    }

    set autoscaleview(value) {
        this._autoscaleview = toBool(value);
        this.pens.forEach((pen) => pen.updateScale())
    }

    get autoscaledefault() {
        return this._autoscaledefault || false;
    }

    set autoscaledefault(value) {
        this._autoscaledefault = toBool(value);
    }

    get expanded() {
        return this._expanded;
    }
    set expanded(v) {
        this._expanded = toBool(v);
    }

    /**
     * Уровень вложенности при которой,
     * Если 0 - то дерево полностью открыто,
     * Если 1 - то открыты только корневые элементы,
     * И так далее
     * @type {number}
     */
    get expandedlevel() {
        return this._expandedLevel || 0;
    }

    set expandedlevel(v) {
        this._expandedLevel = +v;
    }

    /**
     * Тип отображаемого имени:
     * 0 - имя,
     * 1 - описание
     * @type {enum}
     */
    get displaynametype() {
        return this._displayNameType || "0";
    }

    set displaynametype(v) {
        this._displayNameType = v;
    }

    /**
     * Автоматически создавать оси значений
     * @type {boolean}
     */
    get yaxisperpen() {
        return this._yaxisperpen;
    }
    set yaxisperpen(value) {
        this._yaxisperpen = this._toBool(value);
        this.updateYAxisesOffset();
    }

    get archivedatastart(){
        return this._archivedatastart;
    }

    set archivedatastart(v){
        this._archivedatastart = v;
    }

    /**
     * Максимальное количество перьев
     * @type {number}
     */
    get maxpens() {
        if (this._maxpens) return this._maxpens;
        if (!this.getOptionTRN()) return 3;
        return 0;
    }
    set maxpens(value) {
        if (this.getOptionTRN() || +value < 3) this._maxpens = +value;
    }

    get currentPen(){
        return this._currentPen
    }

    set currentPen(v){
        const lastvalue = this._currentPen
        this._currentPen = v
        if(lastvalue !== this._currentPen){
            this.updateSelect()
        }
    }
    
    updateSelect(){
        this.pens.forEach((pen, i) => {
            pen.selected = i === this.currentPen
        })
        this.updatePenYAxis?.()
        this.updateSeriesAxises();
        this.legend.updateSelect();
    }

    /**
     * Изменить свойство пера
     * @param {string} attr имя свойства
     * @param {any} value значение
     */
    changePenAttribute(attr, value) {
        let index = +attr.split(".")[1];
        let parameter = attr.split(".")[2];
        this.pens[index][parameter.toLowerCase()] = value;
        if (this.cache.initialPens !== undefined && this.cache.initialPens.length) {
            this.cache.initialPens[index][parameter.toLowerCase()] = value;
        }
        if (
            parameter.toLowerCase() === "color" &&
            this.usecolorunreliableline === false
        ) {
            // цвет линии недостоверных значений
            this.pens.series[2 * index + 1].lineStyle.normal.color = value;
        }
        this.updateSeriesAxises();
        if (this.saveStateFlag) this.saveState()
    }
    /**
     * Обновить перья и оси в echarts
     * */
    updateSeriesAxises() {
        if(this.recreatingPens && !this.isRemovingPen) return
        this.echarts.setOption({
            series: this.pens.series,
            yAxis: this.getYAxis(),
        }, { replaceMerge: ["series", "yAxis"] });
        this.updateYAxisesOffset()
    }
    /**
     * Применить предупредительныве границы
     * @param {Array} markarea области
     * @param {Array} markline линии
     */
    applyMark(markarea, markline) {
        if (this._brushMarkArea) {
            markarea.push(this._brushMarkArea);
        }
        if (this._marksLine) {
            markline = markline.concat(this._marksLine);
        }
        if (!this.pens[this.currentPen]) return
        this.pens.forEach((pen, i) => {
            if (i != this.currentPen && pen.serie.markArea) {
                pen.serie.markArea.data = [];
                pen.serie.markLine.data = [];
            }
        });
        this.pens[this.currentPen].serie.markArea = {
            silent: true,
            data: markarea,
        };
        this.pens[this.currentPen].serie.markLine = { data: markline };
        this.echarts._zr.animation.update();
    }
    /**
     * Инициализация перьев
     * */
    createSeriesOption() {
        this.pens = [];
        this.pens.series = [];
        try {
            let maxpens = this.maxpens;
            if (this.cache.initialPens !== undefined && this.cache.initialPens.length) {
                for (let ind = 0; ind < this.cache.initialPens.length; ind++) {
                    const item = this.cache.initialPens[ind];

                    if (maxpens && ind >= maxpens) {
                        break;
                    }

                    this.addPenSerie(item);
                }
            } else {
                let ind = 0;
                const pens = JSON.parse(this.attributes.data.value);
                for (let penname in pens) {
                    if (maxpens && ind++ >= maxpens) break;
                    this.addPenSerie(pens[penname]);
                }
            }
            this.updateYAxisesOffset();
        } catch (e) { }
    }
    /**
     * Добавить новый источник данных
     * @param {any} link связь
     * @param {any} path имя параметра
     */
    addDataSource(link, path, initial = false) {
        if(initial){
            const i = +path.split(".")[1];
            if (!this.cache.initialPens) this.cache.initialPens = Object.values(JSON.parse(this.attributes.data.value || "{}"))
            const cachedPen = this.cache.initialPens[i]
            if (cachedPen && !cachedPen.path && !cachedPen.itemId){
                cachedPen.path = link.path
                cachedPen.itemId = link.itemId
            }
        }
        if (!this._afterInit) {
            this._cacheDataSource.push({ link, path });
            return;
        }
        if (this._penStates && initial) {
            return
        }
        if (!link.itemId && !link.path) return
        let i = +path.split(".")[1];
        if (i >= this.pens.length) return;

        if (link.type === "STRING") {
            //если перо стринговое
            if (this.stringpens[i])
                //стринговое перо определено
                return;
            this.stringpens[i] = link;
        } else {
            if (!this.initialized) {
                this.awateDataSource.push({ link: link, path: path });
                return;
            }
            if (this.pens[i].itemId === undefined) this.pens[i].itemId = link.itemId;
            if (this.pens[i].path === undefined) this.pens[i].path = link.path;
            link.timestampsToReturn = "Source";
            link.clientHandle = this.penindex++;
            link["queueSize"] = 0;
            this.pens[i].clientHandle = link.clientHandle;
            this.pens.series[i * 2].data = [];
            this.pens.series[i * 2 + 1].data = [];
            this.isbusy = true;
            this.countWaitGetArhive += 1
            this.sw &&
                this.sw.getArchiveItems(link).then((result) => { 
                    this.countWaitGetArhive -= 1;
                    this.pens.forEach((pen, j) => {
                        if (pen.itemId === result.itemId && pen.path === result.path) {
                            if (!result.statusCode) {
                                if (result.archiveItemId !== -1) {
                                    this.hasArchive = true;
                                    if (
                                        this.archivedpens[
                                        result.archiveItemId
                                        ] === undefined
                                    ) {
                                        this.archivedpens[
                                            result.archiveItemId
                                        ] = [];
                                    }

                                    let apens =
                                        this.archivedpens[result.archiveItemId];
                                    if (apens.indexOf(j) < 0) {
                                        //если такого пера в архивах еще нет
                                        this.archivedpens.toRequest.push({
                                            archiveItemId: result.archiveItemId,
                                        });
                                        apens.push(j);
                                    }
                                    pen.archiveItemId = result.archiveItemId;
                                    let startTime = result.startTime > 0 ? result.startTime - 2 * 60 * 60 * 1000 : 0; //HACK Убираем 2 часа, так как на сервере могут быть данные, загруженные раньше startTime
                                    if(!Number(this.archivedatastart) || this.archivedatastart > startTime){
                                        this.archivedatastart = startTime
                                    }
                                    if (this.autoscroll) {
                                        if (!Number(this.archiveend) || this.archiveend < result.endTime) {
                                            this.SetParameterSilent(
                                                "archiveend",
                                                result.endTime
                                            );
                                        }
                                    } else {
                                        this.echarts.setOption({
                                            xAxis: {
                                                max: this.till,
                                            },
                                        });
                                    }
                                    if (this.autoscroll) {
                                        this.till = this._archiveend
                                    }
                                    if(result.type === "STRING"){
                                        link.type = "STRING"
                                        this.createMonitoredDataItems(link, i);
                                        this.stringpens[i] = link;
                                        pen.dataPath = path
                                        return
                                    } else {
                                        this.createMonitoredDataItems(link, i);
                                    }
                                    this.getBlocksIfNeeded(true);
                                } else {
                                    this.createMonitoredDataItems(link, i);
                                }
                            } else {
                                $ns.add({
                                    type: "error",
                                    time: new Date().toLocaleString(),
                                    title: i18next.t('trend_error'),
                                    text: String.format(i18next.t("unable_to_subscribe_to_parameter") + ": {}{}", result.itemId, result.path ? `/${result.path}` : "")
                                });
                                return;
                            }
                            if (result.comment) pen.comment = result.comment
                            if (pen.source != result.fullName && result.fullName) {
                                pen.source = result.fullName; //даже если архива нет, у пера всё равно есть источник
                                pen.serie.name = result.fullName;
                                this.pens.series[j * 2 + 1].name = result.fullName;
                                if(!this.awateDataSourceLength && this.savedpenState){
                                    this.saveState();
                                }
                            }
                            if (parseInt(this.displaynametype) && result.decription && result.decription !== pen.name && !pen.isnochangetitle) {
                                pen.name = result.decription;
                            } 

                            if (result.scaleAI) {
                                //если есть шкала у параметра
                                pen.yformat = result.scaleAI.format
                                    ? result.scaleAI.format
                                    : "";
                                pen.unit = result.scaleAI.unit
                                    ? result.scaleAI.unit
                                    : "";
                                if (!pen.saved) {
                                    pen.miny = result.scaleAI.min;
                                    pen.maxy = result.scaleAI.max;
                                    this.saveState();
                                }

                                pen.penlimits = {};
                                pen.penlimits.min = result.scaleAI.min;
                                pen.penlimits.max = result.scaleAI.max;

                                if (result.scaleAI.hihi !== undefined) {
                                    pen.penlimits["hihi"] = {
                                        backgroundcolor: "red",
                                        color: "red",
                                        linestyle: 0,
                                        thickness: 1,
                                        isvisible: true,
                                        datasource: result.scaleAI.hihi,
                                    };
                                }

                                if (result.scaleAI.hi !== undefined) {
                                    pen.penlimits["hi"] = {
                                        backgroundcolor: "yellow",
                                        color: "orange",
                                        linestyle: 0,
                                        thickness: 1,
                                        isvisible: true,
                                        datasource: result.scaleAI.hi,
                                    };
                                }

                                if (result.scaleAI.lo !== undefined) {
                                    pen.penlimits["lo"] = {
                                        backgroundcolor: "yellow",
                                        color: "orange",
                                        linestyle: 0,
                                        thickness: 1,
                                        isvisible: true,
                                        datasource: result.scaleAI.lo,
                                    };
                                }

                                if (result.scaleAI.lolo !== undefined) {
                                    pen.penlimits["lolo"] = {
                                        backgroundcolor: "red",
                                        color: "red",
                                        linestyle: 0,
                                        thickness: 1,
                                        isvisible: true,
                                        datasource: result.scaleAI.lolo,
                                    };
                                }
                                this.calcRightOffset()
                                this.setScope()
                            }
                            if (
                                j === this.currentPen ||
                                this.currentPen === undefined
                            ) {
                                this.waitarhiveCurrentPen = pen
                            }
                            this.echarts.dispatchAction({
                                type: pen.isvisible ? "legendSelect" : "legendUnSelect",
                                name: pen.source || pen.name,
                            });
                        }
                    });
                    if(this.awateDataSourceLength){
                        this.awateDataSourceLength = this.awateDataSourceLength - 1
                        if(this.awateDataSourceLength === 0){
                            this.sourcesSeted = true
                            this.saveState();
                        }
                    }
                    if(this.countWaitGetArhive === 0){
                        this.waitarhiveCurrentPen && this.waitarhiveCurrentPen.updateminmaxy();
                        this.waitarhiveCurrentPen = null;
                        this.updateSeriesAxises()
                        this.legend.render()
                        this.trendGroups.reinit()
                    }
                });
        }
    }

    calcRightOffset() {
        const oneDigitWidth = 6
        const yValues = []
        if (this._markBrush.set) yValues.push(this._markBrush.max)
        else if (this.currentPen !== undefined) {
            const pen = this.pens[this.currentPen]
            if (pen) {
                if (pen.penlimits?.hi?.datasource ?? false) yValues.push(pen.penlimits.hi.datasource)
                if (pen.penlimits?.hihi?.datasource ?? false) yValues.push(pen.penlimits.hihi.datasource)
                if (pen.penlimits?.lo?.datasource ?? false) yValues.push(pen.penlimits.lo.datasource)
                if (pen.penlimits?.lolo?.datasource ?? false) yValues.push(pen.penlimits.lolo.datasource)
            }
        }
        else {
            this.pens.forEach(pen => {
                if (pen.penlimits?.hi?.datasource ?? false) yValues.push(pen.penlimits.hi.datasource)
                if (pen.penlimits?.hihi?.datasource ?? false) yValues.push(pen.penlimits.hihi.datasource)
                if (pen.penlimits?.lo?.datasource ?? false) yValues.push(pen.penlimits.lo.datasource)
                if (pen.penlimits?.lolo?.datasource ?? false) yValues.push(pen.penlimits.lolo.datasource)
            })
        }
        const longestValWidth = yValues.length ? Math.max(...yValues).toString().length * oneDigitWidth : 0
        const right = ChartOffsets.right + longestValWidth - (this.msydatazoom.isvisible ? 0 : this.msydatazoom.width);
        this.echarts.setOption({ grid: { right } });
    }

    /**
     * Создать подписку на данные для получения новых PublishData
     * @param {object} link связь
     * @param {number} i номер пера в массиве перьев
     */
    createMonitoredDataItems(link, i) {
        link.withScaleParams = true
        this.sw &&
            this.sw.CreateMonitoredDataItems([link]).then((data) => {
                if (this._stop) return;
                if (data.code != 0) {
                    console.log(data.code.toString(16));
                    return;
                }
                this.pens[i].monitoredItemId = data.items[0].monitoredItemId;
                this.isbusy = false;
            });
    }
    /**
     * Обновление Тренда
     */
    update() {
        if (this.isbusy) return;
        if (!this.isVisibleFromRoot) return;
        let needRedraw = false;
        this.pens.forEach((pen) => {
            if (pen.drawconstant) {
                let lastElement = pen.serie.data[pen.serie.data.length - 1];
                if (this.archiveend > this.msdatazoom.minvalue) {
                    const seriedata = pen.serie.data;
                    if (lastElement) {
                        if (lastElement[3]) {
                            const preLastElement = seriedata[pen.serie.data.length - 2];
                            if (preLastElement && preLastElement[3]) {
                                seriedata.splice(seriedata.length - 2);
                            } else {
                                seriedata.splice(seriedata.length - 1);
                            }
                            lastElement = seriedata[seriedata.length - 1];
                        }
                        if (lastElement[0] < this.msdatazoom.minvalue) {
                            seriedata.push([
                                this.msdatazoom.minvalue + 1,
                                lastElement[1],
                                lastElement[2],
                                true,
                            ]);
                        }
                        const tm =
                            this.archiveend > lastElement[0]
                                ? this.archiveend
                                : lastElement[0];
                        seriedata.push([
                            tm,
                            lastElement[1],
                            lastElement[2],
                            true,
                        ]);
                        needRedraw = true;
                    }
                }
            } else if (pen.needRedraw) {
                pen.needRedraw = false;
                needRedraw = true;
            }
        });
        for (let i = 0; i < this.pens.series.length; i++) {
            if (i % 2 !== 0 || this.pens.series[i].data[this.pens.series[i].data.length - 1]?.[1] !== null) continue
            const lastTime = this.pens.series[i].data[this.pens.series[i].data.length - 1][0]
            if(this.pens.series[i + 1].data.length){
                const lastValue = this.pens.series[i + 1]?.data[this.pens.series[i + 1].data.length - 1][1]
                if (this.pens.series[i + 1].data[this.pens.series[i + 1].data.length - 1][3]) {
                    this.pens.series[i + 1].data[this.pens.series[i + 1].data.length - 1] = [lastTime, lastValue, undefined, true]
                } else {
                    this.pens.series[i + 1].data.push([lastTime, lastValue, undefined, true])
                }
            }
        }
        if (
            this.pens.rightBorder !== this.msdatazoom.maxvalue ||
            this.pens.leftBorder !== this.msdatazoom.minvalue
        ) {
            this.pens.rightBorder = this.msdatazoom.maxvalue;
            this.pens.leftBorder = this.msdatazoom.minvalue;
            this.updateInsideZoom(this.pens.leftBorder, this.pens.rightBorder);
            needRedraw = true;
        }
        if (needRedraw) {
                const startTime = new Date()
                this.echarts.setOption(
                    {
                        series: this.pens.series,
                        dataZoom: {
                            dataZoomIndex: 0,
                            startValue: this.autoscroll ? this.archiveend - this.interval : this.msdatazoom.minvalue,
                            endValue: this.autoscroll ? this.archiveend : this.msdatazoom.maxvalue,
                        },
                        xAxis: {
                            max: this.archiveend,
                            min: this.archivestart,
                        },
                    },
                    false,
                    true
                );
                if(this.isLog){
                    const endTime = new Date();
                    const proccesTime = +endTime - +startTime;
                    if(proccesTime > 100){
                        this.addLog("Установка данных в echart", startTime, endTime, true)
                    }
                }
                if(this.tableTime){
                    this.echarts.setOption({
                        series: [
                            {
                            markLine: {
                                lineStyle: {
                                    type: "solid",
                                    color: "rgba(0, 0, 0, 1)"
                                },
                            data: [
                                {
                                    xAxis: this.tableTime,
                                    label: {
                                        formatter: getFormattedValue(this.xformat, new Date(this.tableTime)),
                                        color: '#000000',
                                        fontSize: 12,
                                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                        padding: [3, 5, 3, 5],
                                        borderWidth: 0
                                    }
                                }
                                ]
                            }
                        }],
                    })
                }
            this.echarts._zr.animation.update();
        }
    }
    debugFindTrubl(data) {
        const res = data.filter((e, i, a) => {
            return a[i + 1] && e[0] > a[i + 1][0];
        });
        if (res.length > 0) console.log(res);
    }

    formatterDatelocalUtc(date){
        return `${date.toLocaleString()}.${date.getMilliseconds()}`
    }

    addLog(name, startTime, endTime, isExtended){
        const newLog = {
            logId: window.trendLog.length,
            trendId: this.id,
            trendName: this.elname,
            name,
            startTimestamp: +startTime,
            endTimestamp: +endTime,
            startTime: this.formatterDatelocalUtc(startTime),
            endTime: this.formatterDatelocalUtc(endTime),
            proccesTime: `${(+endTime - +startTime) / 1000} сек`,
        }

        if(isExtended){
            const leftDate = new Date(this.till - this.interval)
            const rightDate = new Date(this.till)

            newLog.interval = this.interval
            newLog.intervalTime = convertMillisecondsToTime(this.interval)
            newLog.leftBorderTimestamp = +leftDate
            newLog.rightBorderTimestamp = this.till
            newLog.leftBorder = this.formatterDatelocalUtc(leftDate)
            newLog.rightBorder = this.formatterDatelocalUtc(rightDate)
            const pointsCount = {}
            this.pens.forEach((pen) => {
                pointsCount[pen.name] = pen.serie.data.length;
            })
            newLog.pointsCount = pointsCount
        }

        this.log.push(newLog)
        window.trendLog.push(newLog)
        console.log(JSON.stringify(newLog, null, 2))
    }

    /**
     * Обработчик на новое значение пера
     * @param {object} item новое значение
     */
    onDataSourceChanged(item) {
        if (item.sourceTime > this.archiveend) {
            this.SetParameterSilent("archiveend", item.sourceTime);
        }

        if (this.autoscroll && this.blockEnd && this.blockStart) {
            this.blockEnd = item.sourceTime;
            this.blockStart = item.sourceTime - this.blockInterval;
        }

        const i = this.pens.findIndex(
            (pen) => pen.clientHandle == item.clientHandle
        );
        if(this.pens[i] && this.stringpens.length && this.pens[i].dataPath){
            this.pens[i].path = item.value
            this.onStringPenChanged(this.pens[i].dataPath, item.value)
            this.pens[i].dataPath = null
            return
        }

        if (isNaN(item.value)) return;
        
        if (i === -1)
            //была отписка, но данные успели прийти
            return;
        if (item.type) {
            const type = penlimits[item.type]
            if (!this.pens[i].penlimits) this.pens[i].penlimits = {}
            this.pens[i].penlimits[type.name] = {
                ...type.data, datasource: item.value
            }
            this.calcRightOffset()
            this.setScope()
        } else {
            item.value = processScaleType(item.value, this.pens[i].logscale);
            let unreliableSerieData = this.pens.series[i * 2 + 1].data;
            let serieData = this.pens[i].serie.data;
            const sampler = this.pens[i].sampler;
            sampler.data = serieData;
            sampler.interval_len = this.calcResampleInterval();

            this.clearPen(serieData);
            this.clearPen(unreliableSerieData);

            if ((!isGoodStatusCode(item.statusCode) || item.statusCode == 0xa80000) && item.statusCode !== undefined) {
                if (item.statusCode == 0xa80000) {
                    //это выключенный рантайм
                    unreliableSerieData.push([
                        item.sourceTime,
                        null,
                        item.statusCode,
                    ]);
                } else {
                    unreliableSerieData.push([
                        item.sourceTime,
                        item.value,
                        item.statusCode,
                    ]);
                }
                if (sampler.sPush([item.sourceTime, null, item.statusCode]))
                    this.pens[i].needRedraw = true;
                this.pens[i].unreliable = true;
            } else {
                if (this.pens[i].unreliable) {
                    unreliableSerieData.push([
                        item.sourceTime,
                        item.value,
                        item.statusCode,
                    ]);
                    this.pens[i].unreliable = false;
                } else {
                    if (this.pens[i].unreliable !== undefined) {
                        unreliableSerieData.push([
                            item.sourceTime,
                            null,
                            item.statusCode,
                        ]);
                    }
                }
                if (!this.pens[i].archiveItemId) {
                    if (
                        item.sourceTime > this.till + this.interval &&
                        serieData.length > 0
                    ) {
                        //новая точка ушла за границу
                        this.resetnonarchived = true;
                    } else {
                        if (this.resetnonarchived) {
                            //вернулась в границу. чтобы не было линии между провалом нужно все удалить
                            serieData = [];
                            this.resetnonarchived = false;
                        }
                    }
                }
                if (
                    serieData.length === 0 ||
                    serieData.slice(-1)[0][0] < item.sourceTime
                ) {
                    if (
                        sampler.sPush([
                            item.sourceTime,
                            item.value,
                            item.statusCode,
                        ])
                    )
                        this.pens[i].needRedraw = true;
                } else {
                    const a = serieData.findIndex(
                        (a, b, c) => a[0] >= item.sourceTime
                    );
                    serieData.splice(a);
                    if (
                        sampler.sPush([
                            item.sourceTime,
                            item.value,
                            item.statusCode,
                        ])
                    )
                        this.pens[i].needRedraw = true;
                }
            }
            this.pens[i].lastValue = [item.sourceTime, item.value, item.statusCode];
            let k = 0;
            let blockStart =
                typeof this.blockStart !== "undefined"
                    ? this.blockStart
                    : this._till - this._interval * 2;
            while (
                serieData[k] &&
                serieData[k][0] < blockStart &&
                serieData.length > 2
            ) {
                if (serieData[k + 1] && serieData[k + 1][0] < blockStart) k++;
                else break;
            }
            if (k > 0) {
                serieData.splice(0, k);
            }
            k = serieData.length - 1;
            while (
                k > 0 &&
                serieData[k][0] > this.blockEnd + this._interval &&
                serieData.length > 2
            ) {
                if (serieData[k - 1][0] > this.blockEnd) k--;
                else break;
            }
            if (++k < serieData.length) {
                serieData.splice(k);
            }
            if (unreliableSerieData.length) {
                //у недостоверной линии может не быть точек
                k = 0;
                while (
                    unreliableSerieData.length &&
                    unreliableSerieData[k] &&
                    unreliableSerieData[k][0] < blockStart
                ) {
                    if (
                        unreliableSerieData[k + 1] &&
                        unreliableSerieData[k + 1][0] < blockStart
                    )
                        k++;
                    else break;
                }
                if (k > 0) {
                    unreliableSerieData.splice(0, k);
                }
                k = unreliableSerieData.length - 1;
                while (
                    k >= 0 &&
                    unreliableSerieData[k][0] > this.blockEnd + this._interval
                ) {
                    if (
                        unreliableSerieData[k - 1] &&
                        unreliableSerieData[k - 1][0] > this.blockEnd
                    )
                        k--;
                    else break;
                }
                if (++k < serieData.length) {
                    unreliableSerieData.splice(k);
                }
            }
        }
        if (!this.pens[i].computed && this.pens[i].serie.data.length) {
            this.pens[i].serie.data.forEach((data) => {
                if (!this.pens[i].computed) {
                    this.pens[i].computed = {
                        max: data[1],
                        min: data[1],
                    }
                }
                if (data[1] > this.pens[i].computed.max) this.pens[i].computed.max = data[1]
                if (data[1] < this.pens[i].computed.min) this.pens[i].computed.min = data[1]
            })
            this.pens[i].computed.avarage = (this.pens[i].computed.max + this.pens[i].computed.min) / 2
        } else {
            if (item[1] > this.pens[i].computed.max || item[1] < this.pens[i].computed.min) {
                if (item[1] > this.pens[i].computed.max) this.pens[i].computed.max = item[1]
                if (item[1] < this.pens[i].computed.min) this.pens[i].computed.min = item[1]
                this.pens[i].computed.avarage = (this.pens[i].computed.max + this.pens[i].computed.min) / 2
            }
        }
        this.broadcast();
        if (this.legend) {
            this.legend.setLastValue(
                i,
                item.value,
                this.pens[i].yformat,
                this.pens[i].unit,
                this.pens[i].logscale
            );
        }
    }

    /**
     * Изменение стрингового пера
     * @param {string} propertyPath имя параметра
     * @example Pens[1].DataSource
     * @param {string} value значение
     * @example Объекты.Объект 1.Параметр 1
     */
    onStringPenChanged(propertyPath, value) {
        if (!this._afterInit) {
            this._cacheStringPenChanged.push({ propertyPath, value });
            return;
        }
        let i = +propertyPath.split(".")[1];
        if (!this.stringpens[i]) return;
        if (this.pens[i] && this.pens[i].monitoredItemId)
            this.unsubscribeById(i);
        this.stringpens[i].path = value;
        this.stringpens[i].itemId = 0;
        this.stringpens[i].type = "LREAL";
        this.pens[i].serie.data = []; //сброс старых значений
        this.pens.series[i * 2].data = [];
        this.pens.series[i * 2 + 1].data = [];
        this.addDataSource(this.stringpens[i], propertyPath);
    }
    /**
     * Обработчик при получении с сервера нового времени
     * Нужно для того чтобы Конец Тренда продолжал двигаться вперед при включенной автопрокрутке, даже если новых данных нет (константа)
     * @param {number} time новое время
     */
    onUpdateTime(time) {
        if (time > this.archiveend) {
            this.archiveend = time;
        }
    }

    onItemSubscribed(item, monitoredItemId) {
        this.pens.forEach((pen) => {
            if (pen.itemId == item.itemId && pen.path == item.path)
                pen.monitoredItemId = monitoredItemId;
        });
    }

    /** Получение блоков архива с сервера
     * @async
     * @param {boolean} needUpdate обязательно ли запрашивать архив
     * @return {promise} промис
     * @example
     * интервал = 7 мс, конец = 00:00:00.030 мс 1 января 1970
     * ближайший превосходящий интервал размер блока = 8 (2 в степени 3)
     * номер блока, в который попал конец = 30 / 8 = 3
     * видимые данные на полотне Тренда: 23-30
     * с сервера запросятся блоки 2,3,4, т.е. с 16 мс до 40 мс
     * если пользователь двигает окошко вперед-назад, то попадёт на блоки 1,2,3 или 3,4,5
     * сначала попадёт на уже загруженный блок 2 или 4, и в идеале с сервера придёт ответ до того как окно достигнет блоков 1 или 5
     * если меняется интервал, то размер блока пересчитается, когда интервал станет меньше 4 или больше 8
     * ничего не будет запрашиваться с сервера пока интервал будет в пределах от 4 до 8 и конец от 24 до 32
     * благодаря тому, что блоки фиксированные, это всегда будут одни и те же запросы на сервер, которые можно закешировать
     */
    getBlocksIfNeeded(needUpdate) {
        if (!(this._till && this._interval && this.archivedpens.toRequest.length)) return;
        const K = 2;
        const lnK = Math.log(K);
        //размер блока - ближайшее число степень двойки от интервала
        const bsRank = Math.ceil(Math.log(this.interval) / lnK);
        if (bsRank !== this.currentBlockSizeRank) {
            //изменился ли размер блока
            needUpdate = true;
            this.currentBlockSizeRank = bsRank;
        }
        const blockSize = Math.pow(K, bsRank);
        //небольшие изменения размера интервала не меняют размер блока
        //если значительно меняется конец, то меняется только номер блока
        const block = Math.floor(this.till / blockSize);
        if (this.currentBlock !== block && (!this.autoscroll || (this.autoscroll && this._initAutoscroll))) {
            //изменился ли номер блока
            needUpdate = true;
            this.currentBlock = block;
        }

        if (needUpdate) {
            this.blockStart = (block - 1) * blockSize;
            this.blockEnd = (block + 1) * blockSize;
            this.blockInterval = this.blockEnd - this.blockStart;
            //запрашивается архив на один блок вперед и на один блок назад
            return this.getAsyncArchiveData(
                (block - 1) * blockSize,
                (block + 1) * blockSize,
                this.archivedpens.toRequest
            );
        }
        return;
    }

    /**
     * Метод Следующая страница
     */
    NextPage() {
        if (this.msdatazoom.maxvalue + this.interval > this.archiveend) {
            this.SetParameter("till", this.archiveend);
            this.msdatazoom.updateForDatazoom(this.till - this.interval, this.till)
        } else {
            this.msdatazoom.updateForDatazoom(this.msdatazoom.maxvalue, this.msdatazoom.maxvalue + this.interval)
        }
    }
    /**
     * Метод Предыдущая страница
     */
    PreviousPage() {
        this.msdatazoom.updateForDatazoom(this.msdatazoom.minvalue - this.interval, this.msdatazoom.minvalue)
    }
    /**
     * Метод Первая страница
     */
    FirstPage() {
        this.msdatazoom.updateForDatazoom(this.archivestart, this.archivestart + this.interval)
    }
    /**
     * Метод Последняя страница
     */
    LastPage() {
        this.SetParameter("till", this.archiveend)
        this.msdatazoom.updateForDatazoom(this.archiveend - this.interval, this.archiveend)
    }
    /**
     * Открыть дерево выбора параметров для добавления в качестве перьев
     * */
    ObjectTree() {
        if (!this._ObjectTree) {
            this._ObjectTree = new ObjectTree();
        }
        this._ObjectTree.onUpdate = (newSources) => {
            const oldSources = this.sources || [];
            const toRemove = oldSources.filter(({ id: oldId }) => !newSources.some(({ id: newId }) => newId === oldId))
            toRemove.forEach(({ id }) => this.removePen({ PenName: id }))
            let toAdd = newSources.filter(({ id: newId }) => !oldSources.some(({ id: oldId }) => newId === oldId))
            if (this.trendKits) this.trendKits.activeGroup = null
            if (toRemove.length || toAdd.length) {
                let text, textPen;
                if (toRemove.length) {
                    textPen = toRemove.join(", ");
                    text =
                        toRemove.length === 1
                            ? `Удалено перо: ${textPen}`
                            : `Удалено ${toRemove.length} перьев : ${textPen}\n`;
                }
                if (toAdd.length) {
                    textPen = toAdd.join(", ");
                    text =
                        toAdd.length === 1
                            ? `Добавлено перо: ${textPen}`
                            : `Добавлено ${toAdd.length} перьев : ${textPen}\n`;
                }
                if ($pm.hasPermissions) {
                    const options = {
                        cancel: () => { },
                        customText: `${this.elname} ${text}`,
                        customDialogText: "Добавление/удаление перьев",
                    };
                    $pm.resolveControl(
                        this,
                        "TrendAddPens",
                        () => this.reCreatePens(newSources),
                        options
                    );
                } else {
                    this.reCreatePens(newSources);
                }
            }
        };
        if (!this._isglobal) {
            const { itemId, path } = this._getItemId();
            if(itemId){
                this._ObjectTree.rootitem = itemId;
            } else{
                if(path){
                    this._ObjectTree.rootidfield = "ItemPath"
                    this._ObjectTree.rootitem = path;
                }
            }
        }

        this.sources = this.pens.map(({ source, name }) => ({
            id: source,
            title: name,
        }));
        this._ObjectTree.hasTrend = true;
        this._ObjectTree.selected = this.sources;
        this._ObjectTree.extendedSources = this.extendedSources
        this._ObjectTree.Open(
            this._title,
            this.expandedlevel,
            this.displaynametype,
            this.pennamelevels,
            this.expanded
        );
    }

    Update(){
        this.getBlocksIfNeeded(true)
    }

    reCreatePens(newSources, notSave) {
        this.recreatingPens = true;
        this.isbusy = true;

        const oldSources = this.sources ||
            this.pens?.map(({ source, name }) => ({ id: source, title: name })) || [];

        const toRemove = oldSources.filter(({ id: oldId }) => !newSources.some(({ id: newId }) => newId === oldId))
        toRemove.forEach(({ id }) => this.removePen({ PenName: id }))

        let toAdd = newSources.filter(({ id: newId }) => !oldSources.some(({ id: oldId }) => newId === oldId))

        const toKeep = oldSources.length - toRemove.length;
        if (toKeep < this.maxpens) {
            // Можно добавить ещё перьев
            const canAddN = this.maxpens - toKeep;
            if (canAddN < toAdd.length) {
                $ns.add({
                    type: "warning",
                    time: new Date().toLocaleString(),
                    title: i18next.t('trend_warning'),
                    text: String.format(i18next.t("trend_not_all_added_params"), toAdd.length - canAddN, this.maxpens),
                });
            }
            toAdd.splice(this.maxpens - toKeep);
            toAdd.forEach((pen) => {
                if (pen) {
                    this.addPenMethod({ PenName: pen.id, title: pen.title, color: pen.color });
                }
            });
        } else {
            // Всё занято
            if (toAdd.length) {
                $ns.add({
                    type: "warning",
                    time: new Date().toLocaleString(),
                    title: i18next.t('trend_warning'),
                    text: String.format(i18next.t("trend_not_one_added_params"), toAdd.length, this.maxpens),
                });
            }
        }
        this.sources = newSources
        if (!notSave) this.saveState();
        if (this.trendGroups) this.trendGroups.reinit();
        this.isbusy = false;
        this.updateChartStateView()
        this.recreatingPens = false;
        this.updateSeriesAxises()
        if (!this.pens[this.currentPen]) {
            if (!this.pens.length) this.currentPen = undefined
            else {
                this.currentPen = this.pens[0].idx
                this.pens[0].selected = true
            }
        } else if (!this.pens[this.currentPen].selected) this.pens[this.currentPen].selected = true
        this.updateYAxises()
        this.calcRightOffset()
        this.broadcast();
        this.updateUnreliableLine()
        this.updateVisiblePen();
    }

    updateChartStateView() {
        if (this.pens.length > 0) {
            this.echarts.clear();
            this.createBasePensOptions();
            this.echarts.setOption(this.cacheOptions);
            this.createDataZoom();
            this.initTrendOption();
            this.legend.render?.();
            this.trendGroups.reinit();
        }
    }

    updateVisiblePen(){
        this.pens.forEach((pen) => {
            this.echarts.dispatchAction({
                type: pen.isvisible ? "legendSelect" : "legendUnSelect",
                name: pen.serie.name
            });
        })
    }

    saveState() {
        if (!this._afterInit || !this.sourcesSeted) return;
        const pensForSave = [];
        for (let i = 0; i < this.pens.length; i++) {
            const pen = this.pens[i];
            pensForSave.push({
                source: pen.source,
                title: pen.name,
                color: pen.color,
                miny: pen._miny,
                maxy: pen._maxy,
                unit: pen._unit,
                yformat: pen.yformat,
                thickness: pen.thickness,
                linestyle: pen.linestyle,
                linejoin: pen.linejoin,
                pointtype: pen.pointtype,
                pointsize: pen.pointsize,
                showaxis: pen.showaxis,
                isvisible: pen.isvisible,
                drawconstant: pen.drawconstant,
                autoscale: pen.autoscale,
                groupname: pen.groupname,
                mainpengroup: pen.mainpengroup,
                yaxislabel: pen.yaxislabel,
                isnochangetitle: pen.isnochangetitle,
            });
        }
        this.saveItemState({ penStates: pensForSave }, this.windowId);
        this.savedpenState = true;
    }

    saveStateInterval() {
        if (!this._afterInit) return;
        this.saveItemState({
            intervalState: {
                till: this.till,
                interval: this.interval,
                autoscroll: this.autoscroll,
            },
        }, this.windowId);
    }

    saveCurentPenState(start, end) {
        if (!this._afterInit) return;
        this.saveItemState({
            curentPenState: {
                currentPen: this.currentPen,
                start: start,
                end: end,
            },
        }, this.windowId);
    }

    setPenNameBySource(source) {
        let name
        if (this.pennamelevels <= 1) name = source.split(".").pop();
        else {
            let parts = source.split(".");
            let starti =
                parts.length > this.pennamelevels
                    ? parts.length - this.pennamelevels
                    : 0;
            name = parts.slice(starti, parts.length).join(".");
        }
        return name
    }

    get showlegend() {
        return this._showlegend;
    }
    set showlegend(v) {
        const value = this._toBool(v)
        this._showlegend = value;
        if (this.legend){
            if(value){
                if(!this._afterInit){
                    // Задержка нужна для того, чтобы тренд прогрузился и имел финальную ширину
                    setTimeout(() => {
                        this.legend.toggle(true)
                    }, 10)
                } else {
                    this.legend.toggle(true)
                }
            } else {
                this.legend.toggle(false)
            }
        }
    }

    get penStates() {
        return this._penStates;
    }
    set penStates(v) {
        this._penStates = v;
    }

    get pensdata() {
        return this._pens;
    }

    set pensdata(v) {
        try {
            const checkKey = Object.keys(v.value)[0]
            const pensData = this.pens?.map(pen => ({
                source: pen.source,
                name: pen.name,
            }));
            this._pens = []
            pensData?.forEach(pen => this.removePen({ PenName: pen.source }));
            this.awateDataSource = []
            if (isNaN(parseInt(checkKey))) this.windowPens(v)
            else this.programPens(v)
            if (this.legend) {
                this.legend.createPens()
                this.legend.render()
            }
        } catch (e) {
            console.log('error in pensdata ', e)
        }
    }

    windowPens(v) {
        const keys = Object.keys(v.value)
        for (const key of keys) {
            const data = deepClone(v.value[key], true)
            this._pens.push(data)
            // data.penIndex = this.pens.length
            if (isNaN(data.datasource)) {
                data.title = this.setPenNameBySource(data.datasource)
                data.PenName = data.datasource
                this.addPenMethod(data)
            }
        }
    }

    programPens(v) {
        for (const value of v.value) {
            if (!value['Znachenie'] || !isNaN(value['Znachenie'])) continue
            const pen = this._pens.find(pen => pen.PenName === value['Znachenie'])
            if (pen) {
                const drawPen = this.pens.find(p => p.source === pen.PenName)
                drawPen.miny = value['MinY']
                drawPen.maxy = value['MaxY']
                drawPen.color = value['Cvet_pera']
                drawPen.linestyle = value['Stilj_linii']
                drawPen.isvisible = value['Vidimostj']
                drawPen.autoscale = value['Avtomasshtabirovanie']
                drawPen.showaxis = value['Otobrazhatj_osj_znachenij']
            } else {
                const data = {
                    maxy: value['MaxY'],
                    miny: value['MinY'],
                    color: value['Cvet_pera'],
                    linestyle: value['Stilj_linii'],
                    isvisible: value['Vidimostj'],
                    autoscale: value['Avtomasshtabirovanie'],
                    showaxis: value['Otobrazhatj_osj_znachenij'],
                    datasource: value['Znachenie'],
                    unit: value['Edinica_izmereniya'],
                    tickcounty: value['Format_znachenij_Y'],
                    drawconstant: value['Dorisovka_konstant'],
                    linejoin: value['Tip_grafika'],
                    pointtype: value['Tip_tochek'],
                    pointsize: value['Razmer_tochek'],
                    title: this.setPenNameBySource(value['Znachenie']),
                    PenName: value['Znachenie'],
                }
                // data.penIndex = this.pens.length
                this._pens.push(data)
                this.addPenMethod(data)
            }
        }
    }

    get penNamedStates() {
        return this._penNamedStates;
    }
    set penNamedStates(v) {
        this._penNamedStates = v;
    }

    get hideinterval() {
        return this._hideinterval;
    }
    set hideinterval(value) {
        this._hideinterval = this._toBool(value);
        this.toggleTimeinterval();
    }

    get intervalState() {
        return this._intervalState;
    }
    set intervalState(v) {
        this._intervalState = v;
    }

    get curentPenState() {
        return this._curentPenState;
    }
    set curentPenState(v) {
        this._curentPenState = v;
    }
    /**
     * Использовать цвет линии недостоверных значений у тренда для всех его перьев
     * @type {boolean}
     */
    get usecolorunreliableline() {
        return this._usecolorunreliableline;
    }
    set usecolorunreliableline(value) {
        this._usecolorunreliableline = this._toBool(value);
        if (this._usecolorunreliableline) {
            this.colorunreliableline = this.colorunreliableline;
        } else {
            this.pens.series.forEach((serie, i, series) => {
                if (i % 2 === 1) {
                    serie.lineStyle.normal.color =
                        series[i - 1].lineStyle.normal.color;
                }
            });
        }
    }
    /**
     * Цвет линии недостоверных значений
     * @type {string}
     */
    get colorunreliableline() {
        return this._colorunreliableline;
    }
    set colorunreliableline(value) {
        this._colorunreliableline = value;
        if (this.usecolorunreliableline) {
            this.pens.series.forEach((serie, i) => {
                if (i % 2 === 1) {
                    serie.lineStyle.emphasis.color = value;
                    serie.lineStyle.normal.color = value;
                }
            });
        }
    }
    /**
     * Стиль линии недостоверных значений
     * @type {BorderStyleType}
     */
    get styleunreliableline() {
        return this._styleunreliableline;
    }
    set styleunreliableline(value) {
        this._styleunreliableline = value;
        let newstyle = window._enums.PenStyleType[value];
        if (newstyle !== "none") {
            this.pens.series.forEach((serie, i) => {
                if (i % 2 === 1) {
                    serie.lineStyle.normal.type = newstyle;
                    serie.lineStyle.normal.opacity = 1.0;
                }
            });
        } else {
            this.pens.series.forEach((serie, i) => {
                if (i % 2 === 1) {
                    serie.lineStyle.normal.opacity = 0.0;
                }
            });
        }
    }

    updateUnreliableLine(){
        if(this.styleunreliableline){
            let newstyle = window._enums.PenStyleType[this.styleunreliableline];
            if (newstyle !== "none") {
                this.pens.series.forEach((serie, i) => {
                    if (i % 2 === 1) {
                        serie.lineStyle.normal.type = newstyle;
                        serie.lineStyle.normal.opacity = 1.0;
                    }
                });
            } else {
                this.pens.series.forEach((serie, i) => {
                    if (i % 2 === 1) {
                        serie.lineStyle.normal.opacity = 0.0;
                    }
                });
            }
        }
        if(this.colorunreliableline){
            this.pens.series.forEach((serie, i, series) => {
                if (i % 2 === 1) {
                    serie.lineStyle.emphasis.color = this.usecolorunreliableline ? this.colorunreliableline : series[i - 1].lineStyle.normal.color;
                    serie.lineStyle.normal.color = this.usecolorunreliableline ? this.colorunreliableline : series[i - 1].lineStyle.normal.color;
                }
            });
        }
    }

    /**
     * Дорисовка констант по умолчанию
     * @type {boolean}
     */
    get drawconstantdefault() {
        return this._drawconstantdefault;
    }
    set drawconstantdefault(value) {
        this._drawconstantdefault = this._toBool(value);
    }

    /**
     * Тип графика по умолчанию
     * @type {number}
     */
    get linejoindefault() {
        return this._linejoindefault;
    }
    set linejoindefault(value) {
        this._linejoindefault = +value;
    }

    /**
     * Тип графика по умолчанию
     * @type {number}
     */
    get pennamelevels() {
        if (this._pennamelevels == null) return 1;
        return this._pennamelevels;
    }
    set pennamelevels(value) {
        this._pennamelevels = +value;
        this.pens.forEach(pen => {
            if (pen.source) {
                const sources = pen.source.split('.')
                const index = sources.length > this._pennamelevels ? this._pennamelevels : sources.length
                pen.name = sources.slice(sources.length - index, sources.length).join('.')
            }
        })
        if (this.legend) this.legend.render()
    }

    /**
     * @async
     * Асинхронный запрос архива с сервера
     * @param {number} startTime время начала в мс
     * @param {number} endTime время конца в мс
     * @param {Array} pens архивные перья для запроса
     * @returns {promise} промис
     */
    getAsyncArchiveData(startTime, endTime, pens, init) {
        if (!this.startTimeRequest && this.isLog){
            this.startTimeRequest = new Date()
        }
        if (this._preLoad) {
            this._preLoad.classList.add("show");
        }

        const resampleInterval = this.calcResampleInterval()
        this.historyReadRawAsyncLog = null
        this.historyReadRawAsyncLog = {
            date: new Date(),
            startTime,
            endTime,
            resampleInterval,
            pens,
        }

        return this.sw
            .getAsyncArchiveData(
                startTime,
                endTime,
                resampleInterval,
                pens
            )
            .then((result) => this.processArchiveData(result, init))
            .catch((err) => {
                console.log(err);
            });
    }

    /**
     * Обработка архивных данных после получения с сервера
     * @param {Array} result данные из ответа
     * @param {boolean} init является ли этот запрос для Тренда первым
     */
    processArchiveData(packet, init) {
        if (packet && packet.length > 0) {
            if (!init) {
                for (let key in this.archivedpens) {
                    if (key !== "toRequest") {
                        for (let pen of this.archivedpens[key]) {
                            this.pens.series[pen * 2].data = [];
                            this.pens.series[pen * 2 + 1].data = []; //опустошить массив
                            // this.pens[pen].serie.data = []; //опустошить массив
                        }
                    }
                }
            }
            packet.forEach((element) => {
                if (element) {
                    element.forEach((result) => {
                        this.archivedpens[result.archiveItemId].forEach(
                            (penIndex, arrIndex) => {
                                if (
                                    result.values && result.values.length > 0 &&
                                    result.values[0][2] !== undefined
                                ) {
                                    //если данные есть и у них есть метка качества
                                    result.values.forEach((data, index) => {
                                        //тип шкалы: простой/log10
                                        data[0] = processScaleType(
                                            data[0],
                                            this.pens[penIndex].logscale
                                        );

                                        if (data[2] !== 0) {
                                            if (index > 0) {
                                                if (
                                                    result.values[
                                                    index - 1
                                                    ][2] !== 0
                                                ) {
                                                    this.pens.series[
                                                        penIndex * 2 + 1
                                                    ].data.push(
                                                        result.values[index - 1]
                                                    );
                                                } else {
                                                    this.pens.series[
                                                        penIndex * 2
                                                    ].data.push(
                                                        result.values[index]
                                                    );
                                                }
                                            }
                                            if (data[2] == 0xa80000) {
                                                //это выключенный рантайм
                                                this.pens.series[
                                                    penIndex * 2 + 1
                                                ].data.push([
                                                    data[0],
                                                    null,
                                                    data[2],
                                                ]);
                                            } else {
                                                this.pens.series[
                                                    penIndex * 2 + 1
                                                ].data.push(data);
                                            }
                                            this.pens[penIndex].serie.data.push(
                                                [data[0], null, data[2]]
                                            );
                                        } else {
                                            if (
                                                index > 0 &&
                                                result.values[index - 1][2] != 0
                                            ) {
                                                this.pens.series[
                                                    penIndex * 2 + 1
                                                ].data.push(data);
                                            }
                                            this.pens.series[
                                                penIndex * 2 + 1
                                            ].data.push([
                                                data[0],
                                                null,
                                                data[2],
                                            ]);
                                            if (
                                                this.pens[penIndex].serie.data
                                                    .length === 0 ||
                                                this.pens[
                                                    penIndex
                                                ].serie.data.slice(-1)[0][0] <
                                                data[0]
                                            )
                                                this.pens[
                                                    penIndex
                                                ].serie.data.push(data);
                                        }
                                    });
                                } else {
                                    // if (arrIndex === 0)
                                    //     this.pens[penIndex].serie.data =
                                    //         result.values;
                                    // else
                                    //     this.pens[penIndex].serie.data =
                                    //         result.values.slice(0);
                                }
                            }
                        );
                    });
                }
            });
            if(this.isLog){
                const endTime = new Date
                if(this.startInitTime){
                    this.addLog("Инициализация с запросом данных", this.startInitTime, endTime)
                    this.startInitTime = null
                }
                if(this.startTimeRequest){
                    this.addLog("Запрос данных", this.startTimeRequest, endTime, true)
                    this.startTimeRequest = null;
                }
            }
            if(this.isLogTrendArhive){
                const arhiveLog = {
                    historyReadRawAsync: this.historyReadRawAsyncLog,
                    packet,
                    pensSeries: JSON.parse(JSON.stringify(this.pens.series)),
                    finishDate: new Date()
                }
                this.logArhive.push(arhiveLog)
            }
        }
        this.updateScale();
        if (this._preLoad) {
            this._preLoad.classList.remove("show");
        }
    }
    /**
     * Расчет интервала прореживания в мс. Сервер вернет не более 4 значений на интервал
     * @return {number} Интервал в мс
     * @example
     * Шаг прореживания = 1, Интервал = 1 минута (60000 мс)
     * Ширина Тренда 800 пикселей, масштаб 1:1
     * 60000 * 1 / 800 * 1 = 75
     * На каждые 75 мс сервер вернет не более 4 значений на интервал
     * Если данные изменялись чаще, чем раз в 75 миллисекунд, то в архиве на одно перо придет от 800 до 3200 значений
     * Этого достаточно чтобы на каждый пиксель полотна Тренда было значение
     */
    calcResampleInterval() {
        return (
            ((this.interval * window.__scale.x) / this.attributes.width.value) *
            this.attributes.resampleinterval.value
        );
    }
    /**
     * Вызывается когда элемент встроен в DOM
     * @see https://developer.mozilla.org/en-US/docs/Web/Web_Components/Using_custom_elements
     * */
    connectedCallback() {
        if (typeof this.saveStateFlag === "undefined") {
            this.saveStateFlag = this.calcSaveState();
        }
        if (this.saveStateFlag) {
            this.updateItemState(this.windowId);
        }
        this.sw = new trendWorker("trend_" + this.id);
        this.sw
            .CreateDataSubscription()
            .then(() => {
                this.initialized = true;
                if(this.awateDataSource.length){
                    this.awateDataSourceLength = this.awateDataSource.length
                } else {
                    this.sourcesSeted = true;
                }
                this.awateDataSource.forEach((el) => {
                    if (el.link.itemId === "0") {
                        el.link.itemId = $sw.ItemSubscription._getParentParam(
                            this,
                            "objectid"
                        );
                        if (el.link.taskId === -1) {
                            el.link.taskId =
                                $sw.ItemSubscription._getParentParam(
                                    this,
                                    "taskid"
                                );
                        }
                    }
                    this.addDataSource(el.link, el.path, false);
                });
                this.awateDataSource = [];
            })
            .then(() => {
                this.sw && this.sw.StartWatch();
                if(this.startInitTime && this.isLog){
                    const endTime = new Date() 
                    this.addLog("Инициализация", this.startInitTime, endTime)
                }
            });
        this.sw.LinkUp = this.onDataSourceChanged.bind(this);
        this.sw.UpdateTime = this.onUpdateTime.bind(this);
        this.sw.ItemSubscribed = this.onItemSubscribed.bind(this);
    }

    saveKitsState() {
        if (!this.saveStateFlag) return
        this.saveItemState({
            commonGroupState: {
                groups: this.trendKits.state.groups,
            }
        })
        this.saveItemState({
            groupState: {
                active: this.trendKits?.group?.id || null,
            }
        }, (this.windowId))
        if(this.ipc) this.ipc.send("server", "syncTrendKits", {trendId: this.id});
    }

    syncKits(){
        const storedState = this.getItemState(this.originPath);
        if (!storedState?.commonGroupState?.groups) return
        this.trendKits.state.groups = storedState.commonGroupState.groups
        this.trendKits.generateOptions()
    }

    initKitsState() {
        if (!this.saveNamedGroup || !this.trendKits) return
        const storedState = this.getItemState(this.originPath);
        if (!storedState?.commonGroupState?.groups?.length) return
        this.trendKits.state.groups = storedState.commonGroupState.groups
        const storedStateActive = this.getItemState(this.originPath, this.windowId);
        if (!storedStateActive?.groupState?.active) return
        this.trendKits.activeGroup = storedStateActive.groupState.active
        this.trendKits.generateOptions()
    }

    initCache() {
        const state = this.getItemState(this.originPath, this.windowId);
        if (!this.cache.start) this.cache.start = state?.curentPenState?.start ?? this.msydatazoom.minvalue
        if (!this.cache.end) this.cache.end = state?.curentPenState?.end ?? this.msydatazoom.maxvalue
        if (!this.cache.initialPens) this.cache.initialPens = Object.values(JSON.parse(this.attributes.data.value || "{}"))
        if (!this.cache.currentPen) this.cache.currentPen = state?.curentPenState?.currentPen || 0
    }

    setCurrentPen(idx){
        if(idx === undefined || idx >= this.pens.length){
            this.currentPen = this.pens.find(pen => pen.isvisible)?.idx
        } else {
            this.currentPen = this.pens[idx].isvisible ? idx : this.pens.find(pen => pen.isvisible)?.idx
        }
    }

    afterInitialize() {
        if (this._afterInit) return;
        this._afterInit = true;
        this.initCache()
        this.originPath = this.getOriginPath();
        let storedState = this.getItemState(this.originPath, this.windowId);
        if (storedState?.timeIntervals){
            this.isStateTimeInterval = true
            this.timeInterval && this.timeInterval.setDefaultState()
        }
        if (storedState && storedState.penNamedStates) {
            this._penNamedStates = storedState.penNamedStates;
        }
        if (storedState && storedState.currentPenSetState && typeof storedState.currentPenSetState === "string") {
            this.setCurrentPenSet(storedState.currentPenSetState, false);
            this._currentPenSetState = storedState.currentPenSetState
            if (storedState.currentPenSetState && storedState?.penNamedStates[storedState.currentPenSetState]) {
                this._penStates = structuredClone(storedState.penNamedStates[storedState.currentPenSetState])
            }
        }
        if (this._penStates) {
            this.pens.splice(0, this.pens.length);
            this.pens.series = [];
            this.pens.yaxises = [];
            const pensWithSource = []
            const pensWithoutSource = []
            this._penStates.forEach((pen, i) => {
                if(pen.source){
                    pensWithSource.push({                    
                        id: pen.source,
                        title: pen.title || pen.source,
                    })
                } else {
                    pensWithoutSource.push({
                        name: pen.title,
                        basic: true,
                        color: pen.color,
                        linejoin: pen.linejoin,
                        drawconstant: pen.drawconstant,
                        autoscale: pen.autoscale,
                        i
                    })
                }
            })
            this.reCreatePens(
                pensWithSource,
                true
            );
            if(pensWithoutSource.length){
                pensWithoutSource.forEach((pen) => {
                    const npen = this.addPenSerie(pen)
                    this.addLastAxis();
                    this.setPenStateParams(npen, this.penStates[pen.i])
                })
                this.updateYAxises()
                this.broadcast();
            }

            this._penStates.forEach(pen => {
                pen.groupname = null
                pen.mainpengroup = false
            })
        } else {
            for (let index = 0; index < this._cacheDataSource.length; index++) {
                const element = this._cacheDataSource[index];
                this.addDataSource(element.link, element.path);
            }
            for (
                let index = 0;
                index < this._cacheStringPenChanged.length;
                index++
            ) {
                const element = this._cacheStringPenChanged[index];
                this.onStringPenChanged(element.propertyPath, element.value);
            }
        }
        this.initKitsState()
        let startValue = 0
        let endValue = 0
        this.setCurrentPen(this._curentPenState?.currentPen)
        if (this._curentPenState && this._toBool(this.showverticalscrollbar)) {
            const { start, end } = this._curentPenState;
            startValue = start;
            endValue = end;
        } else {
            if (this.currentPen !== undefined) {
                const { miny, maxy } = this.pens[this.currentPen];
                startValue = miny
                endValue = maxy
                this.saveCurentPenState(startValue, endValue)
            }
        }
        if(this.currentPen !== undefined){
            this.msydatazoom.minvalue = startValue ?? this.msydatazoom.minvalue;
            this.msydatazoom.maxvalue = endValue ?? this.msydatazoom.maxvalue;
            this.updateAxesForZoom();
            this.selectPen(this.currentPen, true);
        }
        this.initIntervalState();
    }

    initIntervalState(){  
        if(this.archiveend){
            if (this._intervalState && this.saveStateFlag) {
                if (this._intervalState.interval) this.updateInterval(!this.intervaldefault ? this._intervalState.interval : this.intervalInitial)
                    if (this._intervalState.till && !this.autoscroll) this.SetParameter("till", this._intervalState.till, true);
                    if (this._intervalState.autoscroll !== undefined && !this.autoscrolldefault) this.SetParameter("autoscroll", this._intervalState.autoscroll);
                    if(this._intervalState.till && this._intervalState.autoscroll !== undefined){
                        this.updateSliderZoom(this._intervalState.till - (!this.intervaldefault ? this._intervalState.interval : this.intervalInitial), this._intervalState.till)
                        this.initedStatedZoom = true
                    }
            delete this._intervalState;
            } else {
                this.updateInterval(this.intervalInitial) 
            }
        }
    }
    /**
     * Вызывается когда элемент удаляется из DOM
     */
    disconnectedCallback() {
        this._stop = true;
        if (this._ObjectTree) {
            this._ObjectTree.dispose();
            delete this._ObjectTree;
        }
        if(this.trendKits) this.trendKits.closeAllWindow();
        this.trendKits = null;
        this.trendGroups.destroy();
        this.trendGroups = null;
        this.legend.destroy();
        this.legend = null;
        this.trendTable.destroy();
        this.trendTable = null;
        if(this.intervalRootElem) this.intervalRootElem.innerHTML = ''
        this.timeInterval = null
        this.pens.forEach((pen, index) => {
            this.unsubscribeById(index);
        });
        for (let i = 0; i < this.pens.length; i++) {
            this.pens[i].destroy();
            this.pens.splice(i, 1);
            this.pens.series.splice(i, 1);
            this.pens.yaxises.splice(i, 1);
            i--;
        }
        window.removeEventListener("ms_message", this.afterSwitch);

        this.sw.ServerAdapter.dispose();
        if(this.ipc) this.ipc.off("client", this.ipcTrendHandler);
        delete this.sw;
        clearInterval(this.updateTime);
        this.echarts.setOption({}, true);
        this.echarts.dispose();
        this.echarts = null;
        super.disconnectedCallback();
    }
    /**
     * Установить значение без записи в Журнал (права доступа)
     * Используется для внутренних изменений параметров (без действий пользователя)
     * @example
     * При включенной автопрокрутке постоянно обновляется параметр Конец, но спамить из-за этого Журнал не нужно
     * @param {any} Param параметр, который нужно установить
     * @param {any} value значение
     */
    SetParameterSilent(Param, value) {
        this.attributeChangedCallback(Param, this[Param], value);
    }

   /**
     * Коллбек по изменению атрибутов элемента
     * @see https://w3c.github.io/webcomponents/spec/custom/
     * @param {string} attrName название атрибута
     * @param {*} oldVal старое значение атрибута
     * @param {*} newVal новое значение атрибута
     */
   attributeChangedCallback(attrName, oldVal, newVal, itemIndex, forced) {
        if(attrName === "interval"){
            if(!this.insidesetinterval){
                this.intervalInitial = newVal   
            } else {
                this.insidesetinterval = false
            }   
        }
        if (oldVal !== newVal) {
            this[attrName] = newVal;
            if (this.prop_link[attrName]) {
                this.prop_link[attrName](
                    this.pId ? this.pId + "/" + this.id : this.id,
                    this.Links[attrName],
                    newVal,
                    attrName,
                    this.ItemIndex
                );
            }
        }
    }

    clearPen(arr) {
        let i = arr.length - 1;
        while (i > 0) {
            if (arr[i][3]) arr.splice(i, 1);
            i--;
        }
    }

    get objectuid() {
        return this._objectuid;
    }
    set objectuid(value) {
        this._objectuid = Number(value);
        if (typeof value === "string" && Number.isNaN(this._objectuid))
            this._objectuid = value;
    }

    get isglobal() {
        return this._isglobal;
    }
    set isglobal(value) {
        this._isglobal = this._toBool(value);
    }

    _getItemId() {
        let result = {};
        if (!this._isglobal) {
            if (this._objectuid === 0) {
                result.itemId = $sw.ItemSubscription._getParentParam(
                    this,
                    "objectid",
                    true
                );
            } else if (typeof this._objectuid === "string") {
                result.itemId = 0;
                result.path = this._objectuid;
            } else {
                result.itemId = this._objectuid;
            }
        }
        return result;
    }
}
